import { Component, ElementRef, Inject, ChangeDetectorRef, Input, NgModule, Optional } from '@angular/core';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
var defaultAttributes = {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': 2,
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
};

const Activity = [
    'svg',
    defaultAttributes,
    [['polyline', { points: '22 12 18 12 15 21 9 3 6 12 2 12' }]],
];

const Airplay = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M5 17H4a2 2 0 01-2-2V5a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2h-1',
            },
        ],
        ['polygon', { points: '12 15 17 21 7 21 12 15' }],
    ],
];

const AlarmCheck = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 21a8 8 0 100-16 8 8 0 000 16z' }],
        ['path', { d: 'M5 3L2 6' }],
        ['path', { d: 'M22 6l-3-3' }],
        ['path', { d: 'M6 19l-2 2' }],
        ['path', { d: 'M18 19l2 2' }],
        ['path', { d: 'M9 13l2 2 4-4' }],
    ],
];

const AlarmClockOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M19.94 14A8 8 0 0010 5.25m8.13 12.89A8 8 0 116.87 6.86' }],
        ['path', { d: 'M22 6l-3-3' }],
        ['path', { d: 'M6 19l-2 2' }],
        ['path', { d: 'M2 2l20 20' }],
        ['path', { d: 'M4 4L2 6' }],
    ],
];

const AlarmClock = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '13', r: '8' }],
        ['path', { d: 'M12 9v4l2 2' }],
        ['path', { d: 'M5 3L2 6' }],
        ['path', { d: 'M22 6l-3-3' }],
        ['path', { d: 'M6 19l-2 2' }],
        ['path', { d: 'M18 19l2 2' }],
    ],
];

const AlarmMinus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 21a8 8 0 100-16 8 8 0 000 16z' }],
        ['path', { d: 'M5 3L2 6' }],
        ['path', { d: 'M22 6l-3-3' }],
        ['path', { d: 'M6 19l-2 2' }],
        ['path', { d: 'M18 19l2 2' }],
        ['path', { d: 'M9 13h6' }],
    ],
];

const AlarmPlus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 21a8 8 0 100-16 8 8 0 000 16z' }],
        ['path', { d: 'M5 3L2 6' }],
        ['path', { d: 'M22 6l-3-3' }],
        ['path', { d: 'M6 19l-2 2' }],
        ['path', { d: 'M18 19l2 2' }],
        ['path', { d: 'M12 10v6' }],
        ['path', { d: 'M9 13h6' }],
    ],
];

const Album = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['polyline', { points: '11 3 11 11 14 8 17 11 17 3' }],
    ],
];

const AlertCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '12', y1: '8', x2: '12', y2: '12' }],
        ['line', { x1: '12', y1: '16', x2: '12.01', y2: '16' }],
    ],
];

const AlertOctagon = [
    'svg',
    defaultAttributes,
    [
        [
            'polygon',
            {
                points: '7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2',
            },
        ],
        ['line', { x1: '12', y1: '8', x2: '12', y2: '12' }],
        ['line', { x1: '12', y1: '16', x2: '12.01', y2: '16' }],
    ],
];

const AlertTriangle = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z',
            },
        ],
        ['line', { x1: '12', y1: '9', x2: '12', y2: '13' }],
        ['line', { x1: '12', y1: '17', x2: '12.01', y2: '17' }],
    ],
];

const AlignCenter = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '21', y1: '6', x2: '3', y2: '6' }],
        ['line', { x1: '17', y1: '12', x2: '7', y2: '12' }],
        ['line', { x1: '19', y1: '18', x2: '5', y2: '18' }],
    ],
];

const AlignJustify = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '3', y1: '6', x2: '21', y2: '6' }],
        ['line', { x1: '3', y1: '12', x2: '21', y2: '12' }],
        ['line', { x1: '3', y1: '18', x2: '21', y2: '18' }],
    ],
];

const AlignLeft = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '21', y1: '6', x2: '3', y2: '6' }],
        ['line', { x1: '15', y1: '12', x2: '3', y2: '12' }],
        ['line', { x1: '17', y1: '18', x2: '3', y2: '18' }],
    ],
];

const AlignRight = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '21', y1: '6', x2: '3', y2: '6' }],
        ['line', { x1: '21', y1: '12', x2: '9', y2: '12' }],
        ['line', { x1: '21', y1: '18', x2: '7', y2: '18' }],
    ],
];

const Anchor = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '5', r: '3' }],
        ['line', { x1: '12', y1: '22', x2: '12', y2: '8' }],
        ['path', { d: 'M5 12H2a10 10 0 0020 0h-3' }],
    ],
];

const Aperture = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '14.31', y1: '8', x2: '20.05', y2: '17.94' }],
        ['line', { x1: '9.69', y1: '8', x2: '21.17', y2: '8' }],
        ['line', { x1: '7.38', y1: '12', x2: '13.12', y2: '2.06' }],
        ['line', { x1: '9.69', y1: '16', x2: '3.95', y2: '6.06' }],
        ['line', { x1: '14.31', y1: '16', x2: '2.83', y2: '16' }],
        ['line', { x1: '16.62', y1: '12', x2: '10.88', y2: '21.94' }],
    ],
];

const Archive = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M20 9v9a2 2 0 01-2 2H6a2 2 0 01-2-2V9m16-5H4a2 2 0 00-2 2v1a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm-10 9h4',
            },
        ],
    ],
];

const ArrowBigDown = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M9 3h6v11h4l-7 7-7-7h4z' }]],
];

const ArrowBigLeft = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M3 12l7-7v4h11v6H10v4z' }]],
];

const ArrowBigRight = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M21 12l-7-7v4H3v6h11v4z' }]],
];

const ArrowBigUp = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M9 21V10H5l7-7 7 7h-4v11z' }]],
];

const ArrowDownCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '8 12 12 16 16 12' }],
        ['line', { x1: '12', y1: '8', x2: '12', y2: '16' }],
    ],
];

const ArrowDownLeft = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '17', y1: '7', x2: '7', y2: '17' }],
        ['polyline', { points: '17 17 7 17 7 7' }],
    ],
];

const ArrowDownRight = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '7', y1: '7', x2: '17', y2: '17' }],
        ['polyline', { points: '17 7 17 17 7 17' }],
    ],
];

const ArrowDown = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '12', y1: '5', x2: '12', y2: '19' }],
        ['polyline', { points: '19 12 12 19 5 12' }],
    ],
];

const ArrowLeftCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 8 8 12 12 16' }],
        ['line', { x1: '16', y1: '12', x2: '8', y2: '12' }],
    ],
];

const ArrowLeftRight = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '17 11 21 7 17 3' }],
        ['line', { x1: '21', y1: '7', x2: '9', y2: '7' }],
        ['polyline', { points: '7 21 3 17 7 13' }],
        ['line', { x1: '15', y1: '17', x2: '3', y2: '17' }],
    ],
];

const ArrowLeft = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '19', y1: '12', x2: '5', y2: '12' }],
        ['polyline', { points: '12 19 5 12 12 5' }],
    ],
];

const ArrowRightCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 16 16 12 12 8' }],
        ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
    ],
];

const ArrowRight = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '5', y1: '12', x2: '19', y2: '12' }],
        ['polyline', { points: '12 5 19 12 12 19' }],
    ],
];

const ArrowUpCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '16 12 12 8 8 12' }],
        ['line', { x1: '12', y1: '16', x2: '12', y2: '8' }],
    ],
];

const ArrowUpLeft = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '17', y1: '17', x2: '7', y2: '7' }],
        ['polyline', { points: '7 17 7 7 17 7' }],
    ],
];

const ArrowUpRight = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '7', y1: '17', x2: '17', y2: '7' }],
        ['polyline', { points: '7 7 17 7 17 17' }],
    ],
];

const ArrowUp = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '12', y1: '19', x2: '12', y2: '5' }],
        ['polyline', { points: '5 12 12 5 19 12' }],
    ],
];

const Asterisk = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 6v12' }],
        ['path', { d: 'M17.196 9L6.804 15' }],
        ['path', { d: 'M6.804 9l10.392 6' }],
    ],
];

const AtSign = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '4' }],
        ['path', { d: 'M16 8v5a3 3 0 006 0v-1a10 10 0 10-3.92 7.94' }],
    ],
];

const Award = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '8', r: '7' }],
        ['polyline', { points: '8.21 13.89 7 23 12 20 17 23 15.79 13.88' }],
    ],
];

const Axe = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M14 12l-8.501 8.501a2.12 2.12 0 01-2.998 0h-.002a2.12 2.12 0 010-2.998L11 9.002',
            },
        ],
        [
            'path',
            { d: 'M9 7l4-4 6 6h3l-.13.648a7.648 7.648 0 01-5.081 5.756L15 16v-3z' },
        ],
    ],
];

const Banknote = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '6', width: '20', height: '12', rx: '2' }],
        ['circle', { cx: '12', cy: '12', r: '2' }],
        ['path', { d: 'M6 12h.01M18 12h.01' }],
    ],
];

const BarChart2 = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '18', y1: '20', x2: '18', y2: '10' }],
        ['line', { x1: '12', y1: '20', x2: '12', y2: '4' }],
        ['line', { x1: '6', y1: '20', x2: '6', y2: '14' }],
    ],
];

const BarChart = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '12', y1: '20', x2: '12', y2: '10' }],
        ['line', { x1: '18', y1: '20', x2: '18', y2: '4' }],
        ['line', { x1: '6', y1: '20', x2: '6', y2: '16' }],
    ],
];

const BatteryCharging = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M14 7h2a2 2 0 012 2v6a2 2 0 01-2 2h-3' }],
        ['path', { d: 'M7 7H4a2 2 0 00-2 2v6a2 2 0 002 2h2' }],
        ['polyline', { points: '11 7 8 12 12 12 9 17' }],
        ['line', { x1: '22', x2: '22', y1: '11', y2: '13' }],
    ],
];

const BatteryFull = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '7', width: '16', height: '10', rx: '2', ry: '2' }],
        ['line', { x1: '22', x2: '22', y1: '11', y2: '13' }],
        ['line', { x1: '6', x2: '6', y1: '10', y2: '14' }],
        ['line', { x1: '10', x2: '10', y1: '10', y2: '14' }],
        ['line', { x1: '14', x2: '14', y1: '10', y2: '14' }],
    ],
];

const BatteryLow = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '7', width: '16', height: '10', rx: '2', ry: '2' }],
        ['line', { x1: '22', x2: '22', y1: '11', y2: '13' }],
        ['line', { x1: '6', x2: '6', y1: '10', y2: '14' }],
    ],
];

const BatteryMedium = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '7', width: '16', height: '10', rx: '2', ry: '2' }],
        ['line', { x1: '22', x2: '22', y1: '11', y2: '13' }],
        ['line', { x1: '6', x2: '6', y1: '10', y2: '14' }],
        ['line', { x1: '10', x2: '10', y1: '10', y2: '14' }],
    ],
];

const Battery = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '7', width: '16', height: '10', rx: '2', ry: '2' }],
        ['line', { x1: '22', x2: '22', y1: '11', y2: '13' }],
    ],
];

const Beaker = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4.5 3h15' }],
        ['path', { d: 'M6 3v16a2 2 0 002 2h8a2 2 0 002-2V3' }],
        ['path', { d: 'M6 14h12' }],
    ],
];

const BellMinus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M13.73 21a2 2 0 01-3.46 0' }],
        ['path', { d: 'M21 5h-6' }],
        [
            'path',
            { d: 'M18.021 9C18.29 15.193 21 17 21 17H3s3-2 3-9a6 6 0 017-5.916' },
        ],
    ],
];

const BellOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M13.73 21a2 2 0 01-3.46 0' }],
        ['path', { d: 'M18.63 13A17.888 17.888 0 0118 8' }],
        ['path', { d: 'M6.26 6.26A5.86 5.86 0 006 8c0 7-3 9-3 9h14' }],
        ['path', { d: 'M18 8a6 6 0 00-9.33-5' }],
        ['path', { d: 'M2 2l20 20' }],
    ],
];

const BellPlus = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M18.387 12C19.198 15.799 21 17 21 17H3s3-2 3-9a6 6 0 017-5.916' },
        ],
        ['path', { d: 'M13.73 21a2 2 0 01-3.46 0' }],
        ['path', { d: 'M18 2v6' }],
        ['path', { d: 'M21 5h-6' }],
    ],
];

const BellRing = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9' }],
        ['path', { d: 'M13.73 21a2 2 0 01-3.46 0' }],
        ['path', { d: 'M2 8c0-2.2.7-4.3 2-6' }],
        ['path', { d: 'M22 8a10 10 0 00-2-6' }],
    ],
];

const Bell = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9' }],
        ['path', { d: 'M13.73 21a2 2 0 01-3.46 0' }],
    ],
];

const Bike = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '5.5', cy: '17.5', r: '3.5' }],
        ['circle', { cx: '18.5', cy: '17.5', r: '3.5' }],
        ['path', { d: 'M15 6a1 1 0 100-2 1 1 0 000 2zm-3 11.5V14l-3-3 4-3 2 3h2' }],
    ],
];

const Binary = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M10 4H6v6h4V4z' }],
        ['path', { d: 'M18 14h-4v6h4v-6z' }],
        ['path', { d: 'M14 4h2v6m-2 0h4' }],
        ['path', { d: 'M6 14h2v6m-2 0h4' }],
    ],
];

const Bitcoin = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042l-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893l-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042l.348-1.97M7.48 20.364l3.126-17.727',
            },
        ],
    ],
];

const BluetoothConnected = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M7 7l10 10-5 5V2l5 5L7 17' }],
        ['line', { x1: '18', y1: '12', y2: '12', x2: '21' }],
        ['line', { x1: '3', y1: '12', y2: '12', x2: '6' }],
    ],
];

const BluetoothOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17 17l-5 5V12l-5 5' }],
        ['path', { d: 'M2 2l20 20' }],
        ['path', { d: 'M14.5 9.5L17 7l-5-5v4.5' }],
    ],
];

const BluetoothSearching = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M7 7l10 10-5 5V2l5 5L7 17' }],
        ['path', { d: 'M20.83 14.83a4 4 0 000-5.66' }],
        ['path', { d: 'M18 12h.01' }],
    ],
];

const Bluetooth = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M7 7l10 10-5 5V2l5 5L7 17' }]],
];

const Bold = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6z' }],
        ['path', { d: 'M6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z' }],
    ],
];

const BookOpen = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z' }],
        ['path', { d: 'M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z' }],
    ],
];

const Book = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 19.5A2.5 2.5 0 016.5 17H20' }],
        [
            'path',
            { d: 'M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z' },
        ],
    ],
];

const BookmarkMinus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M19 21l-7-4-7 4V5a2 2 0 012-2h10a2 2 0 012 2v16z' }],
        ['line', { x1: '15', x2: '9', y1: '10', y2: '10' }],
    ],
];

const BookmarkPlus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M19 21l-7-4-7 4V5a2 2 0 012-2h10a2 2 0 012 2v16z' }],
        ['line', { x1: '12', x2: '12', y1: '7', y2: '13' }],
        ['line', { x1: '15', x2: '9', y1: '10', y2: '10' }],
    ],
];

const Bookmark = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M19 21l-7-4-7 4V5a2 2 0 012-2h10a2 2 0 012 2v16z' }]],
];

const Bot = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '11', width: '18', height: '10', rx: '2' }],
        ['circle', { cx: '12', cy: '5', r: '2' }],
        ['path', { d: 'M12 7v4' }],
        ['line', { x1: '8', y1: '16', x2: '8', y2: '16' }],
        ['line', { x1: '16', y1: '16', x2: '16', y2: '16' }],
    ],
];

const BoxSelect = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 2a2 2 0 00-2 2' }],
        ['line', { x1: '8', y1: '2', x2: '10', y2: '2' }],
        ['line', { x1: '14', y1: '2', x2: '16', y2: '2' }],
        ['path', { d: 'M4 22a2 2 0 01-2-2' }],
        ['line', { x1: '22', y1: '8', x2: '22', y2: '10' }],
        ['line', { x1: '22', y1: '14', x2: '22', y2: '16' }],
        ['path', { d: 'M22 20a2 2 0 01-2 2' }],
        ['line', { x1: '14', y1: '22', x2: '16', y2: '22' }],
        ['line', { x1: '8', y1: '22', x2: '10', y2: '22' }],
        ['path', { d: 'M20 2a2 2 0 012 2' }],
        ['line', { x1: '2', y1: '14', x2: '2', y2: '16' }],
        ['line', { x1: '2', y1: '8', x2: '2', y2: '10' }],
    ],
];

const Box = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z',
            },
        ],
        ['polyline', { points: '3.27 6.96 12 12.01 20.73 6.96' }],
        ['line', { x1: '12', y1: '22.08', x2: '12', y2: '12' }],
    ],
];

const Briefcase = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '7', width: '20', height: '14', rx: '2', ry: '2' }],
        ['path', { d: 'M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16' }],
    ],
];

const Brush = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M9.06 11.9l8.07-8.06a2.85 2.85 0 114.03 4.03l-8.06 8.08' }],
        [
            'path',
            {
                d: 'M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 00-3-3.02z',
            },
        ],
    ],
];

const Bug = [
    'svg',
    defaultAttributes,
    [
        ['rect', { width: '8', height: '14', x: '8', y: '6', rx: '4' }],
        ['path', { d: 'M19 7l-3 2' }],
        ['path', { d: 'M5 7l3 2' }],
        ['path', { d: 'M19 19l-3-2' }],
        ['path', { d: 'M5 19l3-2' }],
        ['path', { d: 'M20 13h-4' }],
        ['path', { d: 'M4 13h4' }],
        ['path', { d: 'M10 4l1 2' }],
        ['path', { d: 'M14 4l-1 2' }],
    ],
];

const Building = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '4', y: '2', width: '16', height: '20', rx: '2', ry: '2' }],
        ['path', { d: 'M9 22v-4h6v4' }],
        ['path', { d: 'M8 6h.01' }],
        ['path', { d: 'M16 6h.01' }],
        ['path', { d: 'M12 6h.01' }],
        ['path', { d: 'M12 10h.01' }],
        ['path', { d: 'M12 14h.01' }],
        ['path', { d: 'M16 10h.01' }],
        ['path', { d: 'M16 14h.01' }],
        ['path', { d: 'M8 10h.01' }],
        ['path', { d: 'M8 14h.01' }],
    ],
];

const Bus = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M19 17h2l.64-2.54a6 6 0 000-2.92l-1.07-4.27A3 3 0 0017.66 5H4a2 2 0 00-2 2v10h2m10 0h-4',
            },
        ],
        ['circle', { cx: '6.5', cy: '17.5', r: '2.5' }],
        ['circle', { cx: '16.5', cy: '17.5', r: '2.5' }],
    ],
];

const Calculator = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '4', y: '2', width: '16', height: '20', rx: '2' }],
        ['line', { x1: '8', x2: '16', y1: '6', y2: '6' }],
        ['line', { x1: '16', x2: '16', y1: '14', y2: '18' }],
        ['path', { d: 'M16 10h.01' }],
        ['path', { d: 'M12 10h.01' }],
        ['path', { d: 'M8 10h.01' }],
        ['path', { d: 'M12 14h.01' }],
        ['path', { d: 'M8 14h.01' }],
        ['path', { d: 'M12 18h.01' }],
        ['path', { d: 'M8 18h.01' }],
    ],
];

const Calendar = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '4', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '16', y1: '2', x2: '16', y2: '6' }],
        ['line', { x1: '8', y1: '2', x2: '8', y2: '6' }],
        ['line', { x1: '3', y1: '10', x2: '21', y2: '10' }],
    ],
];

const CameraOff = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '2', y1: '2', x2: '22', y2: '22' }],
        [
            'path',
            {
                d: 'M9.5 4h5L17 7h3a2 2 0 012 2v7.5M7 7H4a2 2 0 00-2 2v9a2 2 0 002 2h16',
            },
        ],
        ['path', { d: 'M14.121 15.121A3 3 0 119.88 10.88' }],
    ],
];

const Camera = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M14.5 4h-5L7 7H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2h-3l-2.5-3z',
            },
        ],
        ['circle', { cx: '12', cy: '13', r: '3' }],
    ],
];

const Car = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M14 16H9m10 0h3v-3.15a1 1 0 00-.84-.99L16 11l-2.7-3.6a1 1 0 00-.8-.4H5.24a2 2 0 00-1.8 1.1l-.8 1.63A6 6 0 002 12.42V16h2',
            },
        ],
        ['circle', { cx: '6.5', cy: '16.5', r: '2.5' }],
        ['circle', { cx: '16.5', cy: '16.5', r: '2.5' }],
    ],
];

const Carrot = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 00-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46',
            },
        ],
        [
            'path',
            { d: 'M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z' },
        ],
        [
            'path',
            { d: 'M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z' },
        ],
    ],
];

const Cast = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M2 16.1A5 5 0 015.9 20M2 12.05A9 9 0 019.95 20M2 8V6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-6',
            },
        ],
        ['line', { x1: '2', y1: '20', x2: '2.01', y2: '20' }],
    ],
];

const CheckCircle2 = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z',
            },
        ],
        ['path', { d: 'M9 12l2 2 4-4' }],
    ],
];

const CheckCircle = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M22 11.08V12a10 10 0 11-5.93-9.14' }],
        ['polyline', { points: '22 4 12 14.01 9 11.01' }],
    ],
];

const CheckSquare = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '9 11 12 14 22 4' }],
        ['path', { d: 'M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11' }],
    ],
];

const Check = [
    'svg',
    defaultAttributes,
    [['polyline', { points: '20 6 9 17 4 12' }]],
];

const ChevronDown = [
    'svg',
    defaultAttributes,
    [['polyline', { points: '6 9 12 15 18 9' }]],
];

const ChevronFirst = [
    'svg',
    defaultAttributes,
    [['polyline', { points: '17 18 11 12 17 6' }], ['path', { d: 'M7 6v12' }]],
];

const ChevronLast = [
    'svg',
    defaultAttributes,
    [['polyline', { points: '7 18 13 12 7 6' }], ['path', { d: 'M17 6v12' }]],
];

const ChevronLeft = [
    'svg',
    defaultAttributes,
    [['polyline', { points: '15 18 9 12 15 6' }]],
];

const ChevronRight = [
    'svg',
    defaultAttributes,
    [['polyline', { points: '9 18 15 12 9 6' }]],
];

const ChevronUp = [
    'svg',
    defaultAttributes,
    [['polyline', { points: '18 15 12 9 6 15' }]],
];

const ChevronsDownUp = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M7 20l5-5 5 5' }], ['path', { d: 'M7 4l5 5 5-5' }]],
];

const ChevronsDown = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '7 13 12 18 17 13' }],
        ['polyline', { points: '7 6 12 11 17 6' }],
    ],
];

const ChevronsLeft = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '11 17 6 12 11 7' }],
        ['polyline', { points: '18 17 13 12 18 7' }],
    ],
];

const ChevronsRight = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '13 17 18 12 13 7' }],
        ['polyline', { points: '6 17 11 12 6 7' }],
    ],
];

const ChevronsUpDown = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M7 15l5 5 5-5' }], ['path', { d: 'M7 9l5-5 5 5' }]],
];

const ChevronsUp = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '17 11 12 6 7 11' }],
        ['polyline', { points: '17 18 12 13 7 18' }],
    ],
];

const Chrome = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['circle', { cx: '12', cy: '12', r: '4' }],
        ['line', { x1: '21.17', y1: '8', x2: '12', y2: '8' }],
        ['line', { x1: '3.95', y1: '6.06', x2: '8.54', y2: '14' }],
        ['line', { x1: '10.88', y1: '21.94', x2: '15.46', y2: '14' }],
    ],
];

const CircleSlashed = [
    'svg',
    defaultAttributes,
    [['circle', { cx: '12', cy: '12', r: '10' }], ['path', { d: 'M22 2L2 22' }]],
];

const Circle = [
    'svg',
    defaultAttributes,
    [['circle', { cx: '12', cy: '12', r: '10' }]],
];

const ClipboardCheck = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2',
            },
        ],
        [
            'path',
            { d: 'M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1z' },
        ],
        ['path', { d: 'M9 13l2 2 4-4' }],
    ],
];

const ClipboardCopy = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M16 4h2a2 2 0 012 2v4M8 4H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2v-2',
            },
        ],
        ['rect', { x: '8', y: '2', width: '8', height: '4', rx: '1', ry: '1' }],
        ['path', { d: 'M21 14H11' }],
        ['path', { d: 'M15 10l-4 4 4 4' }],
    ],
];

const ClipboardList = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2',
            },
        ],
        [
            'path',
            { d: 'M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1z' },
        ],
        ['path', { d: 'M12 11h4' }],
        ['path', { d: 'M12 16h4' }],
        ['path', { d: 'M8 11h.01' }],
        ['path', { d: 'M8 16h.01' }],
    ],
];

const ClipboardX = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2',
            },
        ],
        [
            'path',
            { d: 'M15 2H9a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V3a1 1 0 00-1-1z' },
        ],
        ['path', { d: 'M15 11l-6 6' }],
        ['path', { d: 'M9 11l6 6' }],
    ],
];

const Clipboard = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2',
            },
        ],
        ['rect', { x: '8', y: '2', width: '8', height: '4', rx: '1', ry: '1' }],
    ],
];

const Clock1 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 14.5 8' }],
    ],
];

const Clock10 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 8 10' }],
    ],
];

const Clock11 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 9.5 8' }],
    ],
];

const Clock12 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12' }],
    ],
];

const Clock2 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 16 10' }],
    ],
];

const Clock3 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 16.5 12' }],
    ],
];

const Clock4 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 16 14' }],
    ],
];

const Clock5 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 14.5 16' }],
    ],
];

const Clock6 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 12 16.5' }],
    ],
];

const Clock7 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 9.5 16' }],
    ],
];

const Clock8 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 8 14' }],
    ],
];

const Clock9 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 7.5 12' }],
    ],
];

const Clock = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polyline', { points: '12 6 12 12 16 14' }],
    ],
];

const CloudDrizzle = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
        ['path', { d: 'M8 19v1' }],
        ['path', { d: 'M8 14v1' }],
        ['path', { d: 'M16 19v1' }],
        ['path', { d: 'M16 14v1' }],
        ['path', { d: 'M12 21v1' }],
        ['path', { d: 'M12 16v1' }],
    ],
];

const CloudFog = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
        ['path', { d: 'M16 17H7' }],
        ['path', { d: 'M17 21H9' }],
    ],
];

const CloudHail = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
        ['path', { d: 'M16 14v2' }],
        ['path', { d: 'M8 14v2' }],
        ['path', { d: 'M16 20h0' }],
        ['path', { d: 'M8 20h0' }],
        ['path', { d: 'M12 16v2' }],
        ['path', { d: 'M12 22h0' }],
    ],
];

const CloudLightning = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17.5 17a4.5 4.5 0 100-9h-1.8a7 7 0 10-10.3 8' }],
        ['path', { d: 'M12 12l-3 5h5l-3 5' }],
    ],
];

const CloudMoon = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M13.63 22A3.3 3.3 0 0017 18.79a3.3 3.3 0 00-3.38-3.22h-1.34A5.23 5.23 0 007.25 12 5.13 5.13 0 002 17c0 2.76 2.35 5 5.25 5h6.38z',
            },
        ],
        [
            'path',
            {
                d: 'M9.95 9a6.13 6.13 0 015.5-5.18 4.77 4.77 0 006.67 6.67A6.13 6.13 0 0119.46 15',
            },
        ],
    ],
];

const CloudOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 2l20 20' }],
        ['path', { d: 'M10 5a7 7 0 015.7 5h1.8a4.5 4.5 0 014 6.5' }],
        ['path', { d: 'M18.8 18.8c-.4.2-.8.2-1.3.2H9A7 7 0 015.8 5.8' }],
    ],
];

const CloudRainWind = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
        ['path', { d: 'M9.2 22l3-7' }],
        ['path', { d: 'M9 13l-3 7' }],
        ['path', { d: 'M17 13l-3 7' }],
    ],
];

const CloudRain = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
        ['path', { d: 'M16 14v6' }],
        ['path', { d: 'M8 14v6' }],
        ['path', { d: 'M12 16v6' }],
    ],
];

const CloudSnow = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
        ['path', { d: 'M8 15h0' }],
        ['path', { d: 'M8 19h0' }],
        ['path', { d: 'M12 17h0' }],
        ['path', { d: 'M12 21h0' }],
        ['path', { d: 'M16 15h0' }],
        ['path', { d: 'M16 19h0' }],
    ],
];

const CloudSun = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 2v2' }],
        ['path', { d: 'M5.22 5.22l1.42 1.42' }],
        ['path', { d: 'M20 12h2' }],
        ['path', { d: 'M15.97 12.5A4 4 0 009.5 8.88' }],
        [
            'path',
            {
                d: 'M13.63 22A3.3 3.3 0 0017 18.79a3.3 3.3 0 00-3.38-3.22h-1.34A5.23 5.23 0 007.25 12 5.13 5.13 0 002 17c0 2.76 2.35 5 5.25 5h6.38z',
            },
        ],
        ['path', { d: 'M17.36 6.64l1.42-1.42' }],
    ],
];

const Cloud = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M17.5 19a4.5 4.5 0 100-9h-1.8A7 7 0 109 19h8.5z' }]],
];

const Cloudy = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17.5 21a4.5 4.5 0 100-9h-1.8A7 7 0 109 21h8.5z' }],
        [
            'path',
            {
                d: 'M22 10c0-1.5-1.5-3-3.5-3H17c-.7-2.3-2.9-4-5.4-4-2.7 0-5 2-5.5 4.5',
            },
        ],
    ],
];

const Clover = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M16.2 3.8a2.7 2.7 0 00-3.81 0l-.4.38-.4-.4a2.7 2.7 0 00-3.82 0C6.73 4.85 6.67 6.64 8 8l4 4 4-4c1.33-1.36 1.27-3.15.2-4.2z',
            },
        ],
        [
            'path',
            {
                d: 'M8 8c-1.36-1.33-3.15-1.27-4.2-.2a2.7 2.7 0 000 3.81l.38.4-.4.4a2.7 2.7 0 000 3.82C4.85 17.27 6.64 17.33 8 16',
            },
        ],
        [
            'path',
            {
                d: 'M16 16c1.36 1.33 3.15 1.27 4.2.2a2.7 2.7 0 000-3.81l-.38-.4.4-.4a2.7 2.7 0 000-3.82C19.15 6.73 17.36 6.67 16 8',
            },
        ],
        [
            'path',
            {
                d: 'M7.8 20.2a2.7 2.7 0 003.81 0l.4-.38.4.4a2.7 2.7 0 003.82 0c1.06-1.06 1.12-2.85-.21-4.21l-4-4-4 4c-1.33 1.36-1.27 3.15-.2 4.2z',
            },
        ],
        ['path', { d: 'M7 17l-5 5' }],
    ],
];

const Code2 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18 16l4-4-4-4' }],
        ['path', { d: 'M6 8l-4 4 4 4' }],
        ['path', { d: 'M14.5 4l-5 16' }],
    ],
];

const Code = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '16 18 22 12 16 6' }],
        ['polyline', { points: '8 6 2 12 8 18' }],
    ],
];

const Codepen = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2' }],
        ['line', { x1: '12', y1: '22', x2: '12', y2: '15.5' }],
        ['polyline', { points: '22 8.5 12 15.5 2 8.5' }],
        ['polyline', { points: '2 15.5 12 8.5 22 15.5' }],
        ['line', { x1: '12', y1: '2', x2: '12', y2: '8.5' }],
    ],
];

const Codesandbox = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z',
            },
        ],
        ['polyline', { points: '7.5 4.21 12 6.81 16.5 4.21' }],
        ['polyline', { points: '7.5 19.79 7.5 14.6 3 12' }],
        ['polyline', { points: '21 12 16.5 14.6 16.5 19.79' }],
        ['polyline', { points: '3.27 6.96 12 12.01 20.73 6.96' }],
        ['line', { x1: '12', y1: '22.08', x2: '12', y2: '12' }],
    ],
];

const Coffee = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18 8h1a4 4 0 010 8h-1' }],
        ['path', { d: 'M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z' }],
        ['line', { x1: '6', y1: '1', x2: '6', y2: '4' }],
        ['line', { x1: '10', y1: '1', x2: '10', y2: '4' }],
        ['line', { x1: '14', y1: '1', x2: '14', y2: '4' }],
    ],
];

const Coins = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '8', cy: '8', r: '7' }],
        ['path', { d: 'M19.5 9.94a7 7 0 11-9.56 9.56' }],
        ['path', { d: 'M7 6h1v4' }],
        ['path', { d: 'M17.3 14.3l.7.7-2.8 2.8' }],
    ],
];

const Columns = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '12', y1: '3', x2: '12', y2: '21' }],
    ],
];

const Command = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M18 3a3 3 0 00-3 3v12a3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3H6a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3V6a3 3 0 00-3-3 3 3 0 00-3 3 3 3 0 003 3h12a3 3 0 003-3 3 3 0 00-3-3z',
            },
        ],
    ],
];

const Compass = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        [
            'polygon',
            { points: '16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76' },
        ],
    ],
];

const Contact = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M19 22H5c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2z',
            },
        ],
        ['line', { x1: '16', y1: '2', x2: '16', y2: '4' }],
        ['line', { x1: '8', y1: '2', x2: '8', y2: '4' }],
        ['circle', { cx: '12', cy: '11', r: '3' }],
        ['path', { d: 'M17 18.5c-1.4-1-3.1-1.5-5-1.5s-3.6.6-5 1.5' }],
    ],
];

const Contrast = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['path', { d: 'M12 18a6 6 0 000-12v12z' }],
    ],
];

const Copy = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '9', y: '9', width: '13', height: '13', rx: '2', ry: '2' }],
        ['path', { d: 'M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1' }],
    ],
];

const Copyleft = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['path', { d: 'M9 9.35a4 4 0 110 5.3' }],
    ],
];

const Copyright = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['path', { d: 'M15 9.354a4 4 0 100 5.292' }],
    ],
];

const CornerDownLeft = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '9 10 4 15 9 20' }],
        ['path', { d: 'M20 4v7a4 4 0 01-4 4H4' }],
    ],
];

const CornerDownRight = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '15 10 20 15 15 20' }],
        ['path', { d: 'M4 4v7a4 4 0 004 4h12' }],
    ],
];

const CornerLeftDown = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '14 15 9 20 4 15' }],
        ['path', { d: 'M20 4h-7a4 4 0 00-4 4v12' }],
    ],
];

const CornerLeftUp = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '14 9 9 4 4 9' }],
        ['path', { d: 'M20 20h-7a4 4 0 01-4-4V4' }],
    ],
];

const CornerRightDown = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '10 15 15 20 20 15' }],
        ['path', { d: 'M4 4h7a4 4 0 014 4v12' }],
    ],
];

const CornerRightUp = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '10 9 15 4 20 9' }],
        ['path', { d: 'M4 20h7a4 4 0 004-4V4' }],
    ],
];

const CornerUpLeft = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '9 14 4 9 9 4' }],
        ['path', { d: 'M20 20v-7a4 4 0 00-4-4H4' }],
    ],
];

const CornerUpRight = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '15 14 20 9 15 4' }],
        ['path', { d: 'M4 20v-7a4 4 0 014-4h12' }],
    ],
];

const Cpu = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '4', y: '4', width: '16', height: '16', rx: '2', ry: '2' }],
        ['rect', { x: '9', y: '9', width: '6', height: '6' }],
        ['line', { x1: '9', y1: '1', x2: '9', y2: '4' }],
        ['line', { x1: '15', y1: '1', x2: '15', y2: '4' }],
        ['line', { x1: '9', y1: '20', x2: '9', y2: '23' }],
        ['line', { x1: '15', y1: '20', x2: '15', y2: '23' }],
        ['line', { x1: '20', y1: '9', x2: '23', y2: '9' }],
        ['line', { x1: '20', y1: '14', x2: '23', y2: '14' }],
        ['line', { x1: '1', y1: '9', x2: '4', y2: '9' }],
        ['line', { x1: '1', y1: '14', x2: '4', y2: '14' }],
    ],
];

const CreditCard = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '1', y: '4', width: '22', height: '16', rx: '2', ry: '2' }],
        ['line', { x1: '1', y1: '10', x2: '23', y2: '10' }],
    ],
];

const Crop = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M6.13 1L6 16a2 2 0 002 2h15' }],
        ['path', { d: 'M1 6.13L16 6a2 2 0 012 2v15' }],
    ],
];

const Cross = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M11 2a2 2 0 00-2 2v5H4a2 2 0 00-2 2v2c0 1.1.9 2 2 2h5v5c0 1.1.9 2 2 2h2a2 2 0 002-2v-5h5a2 2 0 002-2v-2a2 2 0 00-2-2h-5V4a2 2 0 00-2-2h-2z',
            },
        ],
    ],
];

const Crosshair = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '22', y1: '12', x2: '18', y2: '12' }],
        ['line', { x1: '6', y1: '12', x2: '2', y2: '12' }],
        ['line', { x1: '12', y1: '6', x2: '12', y2: '2' }],
        ['line', { x1: '12', y1: '22', x2: '12', y2: '18' }],
    ],
];

const Crown = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M2 4l3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14' }]],
];

const Currency = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '8' }],
        ['line', { x1: '3', y1: '3', x2: '6', y2: '6' }],
        ['line', { x1: '21', y1: '3', x2: '18', y2: '6' }],
        ['line', { x1: '3', y1: '21', x2: '6', y2: '18' }],
        ['line', { x1: '21', y1: '21', x2: '18', y2: '18' }],
    ],
];

const Database = [
    'svg',
    defaultAttributes,
    [
        ['ellipse', { cx: '12', cy: '5', rx: '9', ry: '3' }],
        ['path', { d: 'M21 12c0 1.66-4 3-9 3s-9-1.34-9-3' }],
        ['path', { d: 'M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5' }],
    ],
];

const Delete = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 4H8l-7 8 7 8h13a2 2 0 002-2V6a2 2 0 00-2-2z' }],
        ['line', { x1: '18', y1: '9', x2: '12', y2: '15' }],
        ['line', { x1: '12', y1: '9', x2: '18', y2: '15' }],
    ],
];

const Disc = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['circle', { cx: '12', cy: '12', r: '3' }],
    ],
];

const DivideCircle = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
        ['line', { x1: '12', y1: '16', x2: '12', y2: '16' }],
        ['line', { x1: '12', y1: '8', x2: '12', y2: '8' }],
        ['circle', { cx: '12', cy: '12', r: '10' }],
    ],
];

const DivideSquare = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
        ['line', { x1: '12', y1: '16', x2: '12', y2: '16' }],
        ['line', { x1: '12', y1: '8', x2: '12', y2: '8' }],
    ],
];

const Divide = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '6', r: '1' }],
        ['line', { x1: '5', y1: '12', x2: '19', y2: '12' }],
        ['circle', { cx: '12', cy: '18', r: '1' }],
    ],
];

const DollarSign = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '12', y1: '1', x2: '12', y2: '23' }],
        ['path', { d: 'M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6' }],
    ],
];

const DownloadCloud = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
        ['path', { d: 'M12 12v9' }],
        ['path', { d: 'M8 17l4 4 4-4' }],
    ],
];

const Download = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4' }],
        ['polyline', { points: '7 10 12 15 17 10' }],
        ['line', { x1: '12', y1: '15', x2: '12', y2: '3' }],
    ],
];

const Dribbble = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        [
            'path',
            {
                d: 'M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32',
            },
        ],
    ],
];

const Droplet = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M12 22a7 7 0 007-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 007 7z',
            },
        ],
    ],
];

const Droplets = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z',
            },
        ],
        [
            'path',
            {
                d: 'M12.56 6.6A10.97 10.97 0 0014 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 01-11.91 4.97',
            },
        ],
    ],
];

const Drumstick = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M15.45 15.4c-2.13.65-4.3.32-5.7-1.1-2.29-2.27-1.76-6.5 1.17-9.42 2.93-2.93 7.15-3.46 9.43-1.18 1.41 1.41 1.74 3.57 1.1 5.71-1.4-.51-3.26-.02-4.64 1.36-1.38 1.38-1.87 3.23-1.36 4.63z',
            },
        ],
        [
            'path',
            {
                d: 'M11.25 15.6l-2.16 2.16a2.5 2.5 0 11-4.56 1.73 2.49 2.49 0 01-1.41-4.24 2.5 2.5 0 013.14-.32l2.16-2.16',
            },
        ],
    ],
];

const Edit2 = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z' }]],
];

const Edit3 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 20h9' }],
        ['path', { d: 'M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z' }],
    ],
];

const Edit = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7' }],
        ['path', { d: 'M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z' }],
    ],
];

const Egg = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z',
            },
        ],
    ],
];

const EqualNot = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '5', y1: '9', x2: '19', y2: '9' }],
        ['line', { x1: '5', y1: '15', x2: '19', y2: '15' }],
        ['line', { x1: '19', y1: '5', x2: '5', y2: '19' }],
    ],
];

const Equal = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '5', y1: '9', x2: '19', y2: '9' }],
        ['line', { x1: '5', y1: '15', x2: '19', y2: '15' }],
    ],
];

const Euro = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 10h12' }],
        ['path', { d: 'M4 14h9' }],
        [
            'path',
            {
                d: 'M19 6a7.7 7.7 0 00-5.2-2A7.9 7.9 0 006 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2',
            },
        ],
    ],
];

const Expand = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 21l-6-6m6 6v-4.8m0 4.8h-4.8' }],
        ['path', { d: 'M3 16.2V21m0 0h4.8M3 21l6-6' }],
        ['path', { d: 'M21 7.8V3m0 0h-4.8M21 3l-6 6' }],
        ['path', { d: 'M3 7.8V3m0 0h4.8M3 3l6 6' }],
    ],
];

const ExternalLink = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6' }],
        ['polyline', { points: '15 3 21 3 21 9' }],
        ['line', { x1: '10', y1: '14', x2: '21', y2: '3' }],
    ],
];

const EyeOff = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24',
            },
        ],
        ['line', { x1: '1', y1: '1', x2: '23', y2: '23' }],
    ],
];

const Eye = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }],
        ['circle', { cx: '12', cy: '12', r: '3' }],
    ],
];

const Facebook = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z' },
        ],
    ],
];

const FastForward = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '13 19 22 12 13 5 13 19' }],
        ['polygon', { points: '2 19 11 12 2 5 2 19' }],
    ],
];

const Feather = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20.24 12.24a6 6 0 00-8.49-8.49L5 10.5V19h8.5z' }],
        ['line', { x1: '16', y1: '8', x2: '2', y2: '22' }],
        ['line', { x1: '17.5', y1: '15', x2: '9', y2: '15' }],
    ],
];

const Figma = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M5 5.5A3.5 3.5 0 018.5 2H12v7H8.5A3.5 3.5 0 015 5.5z' }],
        ['path', { d: 'M12 2h3.5a3.5 3.5 0 110 7H12V2z' }],
        ['path', { d: 'M12 12.5a3.5 3.5 0 117 0 3.5 3.5 0 11-7 0z' }],
        ['path', { d: 'M5 19.5A3.5 3.5 0 018.5 16H12v3.5a3.5 3.5 0 11-7 0z' }],
        ['path', { d: 'M5 12.5A3.5 3.5 0 018.5 9H12v7H8.5A3.5 3.5 0 015 12.5z' }],
    ],
];

const FileCheck2 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
        ['path', { d: 'M14 2v6h6' }],
        ['path', { d: 'M3 15l2 2 4-4' }],
    ],
];

const FileCheck = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z' },
        ],
        ['polyline', { points: '14 2 14 8 20 8' }],
        ['path', { d: 'M9 15l2 2 4-4' }],
    ],
];

const FileCode = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
        ['path', { d: 'M14 2v6h6' }],
        ['path', { d: 'M9 18l3-3-3-3' }],
        ['path', { d: 'M5 12l-3 3 3 3' }],
    ],
];

const FileDigit = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
        ['path', { d: 'M14 2v6h6' }],
        ['path', { d: 'M10 12h2v6' }],
        ['rect', { x: '2', y: '12', width: '4', height: '6' }],
        ['path', { d: 'M10 18h4' }],
    ],
];

const FileInput = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
        ['path', { d: 'M14 2v6h6' }],
        ['path', { d: 'M2 15h10' }],
        ['path', { d: 'M9 18l3-3-3-3' }],
    ],
];

const FileMinus2 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
        ['path', { d: 'M14 2v6h6' }],
        ['path', { d: 'M3 15h6' }],
    ],
];

const FileMinus = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z' },
        ],
        ['polyline', { points: '14 2 14 8 20 8' }],
        ['line', { x1: '9', y1: '15', x2: '15', y2: '15' }],
    ],
];

const FileOutput = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
        ['path', { d: 'M14 2v6h6' }],
        ['path', { d: 'M2 15h10' }],
        ['path', { d: 'M5 12l-3 3 3 3' }],
    ],
];

const FilePlus2 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
        ['path', { d: 'M14 2v6h6' }],
        ['path', { d: 'M3 15h6' }],
        ['path', { d: 'M6 12v6' }],
    ],
];

const FilePlus = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z' },
        ],
        ['polyline', { points: '14 2 14 8 20 8' }],
        ['line', { x1: '12', y1: '18', x2: '12', y2: '12' }],
        ['line', { x1: '9', y1: '15', x2: '15', y2: '15' }],
    ],
];

const FileSearch = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v3' }],
        ['path', { d: 'M14 2v6h6' }],
        ['path', { d: 'M5 17a3 3 0 100-6 3 3 0 000 6z' }],
        ['path', { d: 'M9 18l-1.5-1.5' }],
    ],
];

const FileText = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z' },
        ],
        ['polyline', { points: '14 2 14 8 20 8' }],
        ['line', { x1: '16', y1: '13', x2: '8', y2: '13' }],
        ['line', { x1: '16', y1: '17', x2: '8', y2: '17' }],
        ['line', { x1: '10', y1: '9', x2: '8', y2: '9' }],
    ],
];

const FileX2 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
        ['path', { d: 'M14 2v6h6' }],
        ['path', { d: 'M3 12.5l5 5' }],
        ['path', { d: 'M8 12.5l-5 5' }],
    ],
];

const FileX = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z' },
        ],
        ['polyline', { points: '14 2 14 8 20 8' }],
        ['line', { x1: '9.5', y1: '12.5', x2: '14.5', y2: '17.5' }],
        ['line', { x1: '14.5', y1: '12.5', x2: '9.5', y2: '17.5' }],
    ],
];

const File = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M14.5 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V7.5L14.5 2z' },
        ],
        ['polyline', { points: '14 2 14 8 20 8' }],
    ],
];

const Files = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M15.5 2H8.6c-.4 0-.8.2-1.1.5-.3.3-.5.7-.5 1.1v12.8c0 .4.2.8.5 1.1.3.3.7.5 1.1.5h9.8c.4 0 .8-.2 1.1-.5.3-.3.5-.7.5-1.1V6.5L15.5 2z',
            },
        ],
        ['path', { d: 'M3 7.6v12.8c0 .4.2.8.5 1.1.3.3.7.5 1.1.5h9.8' }],
        ['path', { d: 'M15 2v5h5' }],
    ],
];

const Film = [
    'svg',
    defaultAttributes,
    [
        [
            'rect',
            { x: '2', y: '2', width: '20', height: '20', rx: '2.18', ry: '2.18' },
        ],
        ['line', { x1: '7', y1: '2', x2: '7', y2: '22' }],
        ['line', { x1: '17', y1: '2', x2: '17', y2: '22' }],
        ['line', { x1: '2', y1: '12', x2: '22', y2: '12' }],
        ['line', { x1: '2', y1: '7', x2: '7', y2: '7' }],
        ['line', { x1: '2', y1: '17', x2: '7', y2: '17' }],
        ['line', { x1: '17', y1: '17', x2: '22', y2: '17' }],
        ['line', { x1: '17', y1: '7', x2: '22', y2: '7' }],
    ],
];

const Filter = [
    'svg',
    defaultAttributes,
    [['polygon', { points: '22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3' }]],
];

const FlagTriangleLeft = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M17 22V2L7 7l10 5' }]],
];

const FlagTriangleRight = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M7 22V2l10 5-10 5' }]],
];

const Flag = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z' },
        ],
        ['line', { x1: '4', y1: '22', x2: '4', y2: '15' }],
    ],
];

const Flame = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z',
            },
        ],
    ],
];

const FlashlightOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M16 16v4a2 2 0 01-2 2h-4a2 2 0 01-2-2V10c0-2-2-2-2-4' }],
        ['path', { d: 'M7 2h11v4c0 2-2 2-2 4v1' }],
        ['line', { x1: '11', y1: '6', x2: '18', y2: '6' }],
        ['line', { x1: '2', y1: '2', x2: '22', y2: '22' }],
    ],
];

const Flashlight = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M18 6c0 2-2 2-2 4v10a2 2 0 01-2 2h-4a2 2 0 01-2-2V10c0-2-2-2-2-4V2h12z',
            },
        ],
        ['line', { x1: '6', y1: '6', x2: '18', y2: '6' }],
        ['line', { x1: '12', y1: '12', x2: '12', y2: '12' }],
    ],
];

const FlaskConical = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M10 2v8L4.72 20.55a1 1 0 00.9 1.45h12.76a1 1 0 00.9-1.45L14 10V2' },
        ],
        ['path', { d: 'M8.5 2h7' }],
        ['path', { d: 'M7 16h10' }],
    ],
];

const FlaskRound = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M10 2v7.31' }],
        ['path', { d: 'M14 9.3V1.99' }],
        ['path', { d: 'M8.5 2h7' }],
        ['path', { d: 'M14 9.3a6.5 6.5 0 11-4 0' }],
        ['path', { d: 'M5.58 16.5h12.85' }],
    ],
];

const FolderMinus = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z',
            },
        ],
        ['line', { x1: '9', y1: '14', x2: '15', y2: '14' }],
    ],
];

const FolderOpen = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M6 17l2-5h14l-3 8a2 2 0 01-2 1H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h7a2 2 0 012 2v4',
            },
        ],
    ],
];

const FolderPlus = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z',
            },
        ],
        ['line', { x1: '12', y1: '11', x2: '12', y2: '17' }],
        ['line', { x1: '9', y1: '14', x2: '15', y2: '14' }],
    ],
];

const Folder = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z',
            },
        ],
    ],
];

const FormInput = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '6', width: '20', height: '12', rx: '2' }],
        ['path', { d: 'M12 12h.01' }],
        ['path', { d: 'M17 12h.01' }],
        ['path', { d: 'M7 12h.01' }],
    ],
];

const Forward = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '15 17 20 12 15 7' }],
        ['path', { d: 'M4 18v-2a4 4 0 014-4h12' }],
    ],
];

const Framer = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7' }]],
];

const Frown = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['path', { d: 'M16 16s-1.5-2-4-2-4 2-4 2' }],
        ['line', { x1: '9', y1: '9', x2: '9.01', y2: '9' }],
        ['line', { x1: '15', y1: '9', x2: '15.01', y2: '9' }],
    ],
];

const FunctionSquare = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['path', { d: 'M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3' }],
        ['path', { d: 'M9 11.2h5.7' }],
    ],
];

const Gamepad2 = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '6', y1: '11', x2: '10', y2: '11' }],
        ['line', { x1: '8', y1: '9', x2: '8', y2: '13' }],
        ['line', { x1: '15', y1: '12', x2: '15.01', y2: '12' }],
        ['line', { x1: '18', y1: '10', x2: '18.01', y2: '10' }],
        [
            'path',
            {
                d: 'M17.32 5H6.68a4 4 0 00-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 003 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 019.828 16h4.344a2 2 0 011.414.586L17 18c.5.5 1 1 2 1a3 3 0 003-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0017.32 5z',
            },
        ],
    ],
];

const Gamepad = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '6', y1: '12', x2: '10', y2: '12' }],
        ['line', { x1: '8', y1: '10', x2: '8', y2: '14' }],
        ['line', { x1: '15', y1: '13', x2: '15.01', y2: '13' }],
        ['line', { x1: '18', y1: '11', x2: '18.01', y2: '11' }],
        ['rect', { x: '2', y: '6', width: '20', height: '12', rx: '2' }],
    ],
];

const Gauge = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 15l3.5-3.5' }],
        [
            'path',
            {
                d: 'M20.3 18c.4-1 .7-2.2.7-3.4C21 9.8 17 6 12 6s-9 3.8-9 8.6c0 1.2.3 2.4.7 3.4',
            },
        ],
    ],
];

const Gavel = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M14 13l-7.5 7.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 010-3L11 10',
            },
        ],
        ['path', { d: 'M16 16l6-6' }],
        ['path', { d: 'M8 8l6-6' }],
        ['path', { d: 'M9 7l8 8' }],
        ['path', { d: 'M21 11l-8-8' }],
    ],
];

const Gem = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '6 3 18 3 22 9 12 22 2 9' }],
        ['path', { d: 'M12 22l4-13-3-6' }],
        ['path', { d: 'M12 22L8 9l3-6' }],
        ['path', { d: 'M2 9h20' }],
    ],
];

const Ghost = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M9 10h.01' }],
        ['path', { d: 'M15 10h.01' }],
        [
            'path',
            {
                d: 'M12 2a8 8 0 00-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 00-8-8z',
            },
        ],
    ],
];

const Gift = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '20 12 20 22 4 22 4 12' }],
        ['rect', { x: '2', y: '7', width: '20', height: '5' }],
        ['line', { x1: '12', y1: '22', x2: '12', y2: '7' }],
        ['path', { d: 'M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z' }],
        ['path', { d: 'M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z' }],
    ],
];

const GitBranchPlus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M6 3v12' }],
        ['path', { d: 'M18 9a3 3 0 100-6 3 3 0 000 6z' }],
        ['path', { d: 'M6 21a3 3 0 100-6 3 3 0 000 6z' }],
        ['path', { d: 'M15 6a9 9 0 00-9 9' }],
        ['path', { d: 'M18 15v6' }],
        ['path', { d: 'M21 18h-6' }],
    ],
];

const GitBranch = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '6', y1: '3', x2: '6', y2: '15' }],
        ['circle', { cx: '18', cy: '6', r: '3' }],
        ['circle', { cx: '6', cy: '18', r: '3' }],
        ['path', { d: 'M18 9a9 9 0 01-9 9' }],
    ],
];

const GitCommit = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '3' }],
        ['line', { x1: '3', y1: '12', x2: '9', y2: '12' }],
        ['line', { x1: '15', y1: '12', x2: '21', y2: '12' }],
    ],
];

const GitMerge = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '18', cy: '18', r: '3' }],
        ['circle', { cx: '6', cy: '6', r: '3' }],
        ['path', { d: 'M6 21V9a9 9 0 009 9' }],
    ],
];

const GitPullRequest = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '18', cy: '18', r: '3' }],
        ['circle', { cx: '6', cy: '6', r: '3' }],
        ['path', { d: 'M13 6h3a2 2 0 012 2v7' }],
        ['line', { x1: '6', y1: '9', x2: '6', y2: '21' }],
    ],
];

const Github = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22',
            },
        ],
    ],
];

const Gitlab = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 01-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 014.82 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0118.6 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.51L23 13.45a.84.84 0 01-.35.94z',
            },
        ],
    ],
];

const Glasses = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '6', cy: '15', r: '4' }],
        ['circle', { cx: '18', cy: '15', r: '4' }],
        ['path', { d: 'M14 15a2 2 0 00-2-2 2 2 0 00-2 2' }],
        ['path', { d: 'M2.5 13L5 7c.7-1.3 1.4-2 3-2' }],
        ['path', { d: 'M21.5 13L19 7c-.7-1.3-1.5-2-3-2' }],
    ],
];

const Globe2 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M15 21v-4a2 2 0 012-2h4' }],
        [
            'path',
            { d: 'M7 4v2a3 3 0 003 2h0a2 2 0 012 2 2 2 0 004 0 2 2 0 012-2h3' },
        ],
        ['path', { d: 'M3 11h2a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v4' }],
        ['circle', { cx: '12', cy: '12', r: '10' }],
    ],
];

const Globe = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '2', y1: '12', x2: '22', y2: '12' }],
        [
            'path',
            {
                d: 'M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z',
            },
        ],
    ],
];

const Grab = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18 11.5V9a2 2 0 00-2-2v0a2 2 0 00-2 2v1.4' }],
        ['path', { d: 'M14 10V8a2 2 0 00-2-2v0a2 2 0 00-2 2v2' }],
        ['path', { d: 'M10 9.9V9a2 2 0 00-2-2v0a2 2 0 00-2 2v5' }],
        ['path', { d: 'M6 14v0a2 2 0 00-2-2v0a2 2 0 00-2 2v0' }],
        [
            'path',
            { d: 'M18 11v0a2 2 0 114 0v3a8 8 0 01-8 8h-4a8 8 0 01-8-8 2 2 0 114 0' },
        ],
    ],
];

const GraduationCap = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M22 10v6M2 10l10-5 10 5-10 5z' }],
        ['path', { d: 'M6 12v5c3 3 9 3 12 0v-5' }],
    ],
];

const Grid = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '3', y1: '9', x2: '21', y2: '9' }],
        ['line', { x1: '3', y1: '15', x2: '21', y2: '15' }],
        ['line', { x1: '9', y1: '3', x2: '9', y2: '21' }],
        ['line', { x1: '15', y1: '3', x2: '15', y2: '21' }],
    ],
];

const GripHorizontal = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '9', r: '1' }],
        ['circle', { cx: '19', cy: '9', r: '1' }],
        ['circle', { cx: '5', cy: '9', r: '1' }],
        ['circle', { cx: '12', cy: '15', r: '1' }],
        ['circle', { cx: '19', cy: '15', r: '1' }],
        ['circle', { cx: '5', cy: '15', r: '1' }],
    ],
];

const GripVertical = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '9', cy: '12', r: '1' }],
        ['circle', { cx: '9', cy: '5', r: '1' }],
        ['circle', { cx: '9', cy: '19', r: '1' }],
        ['circle', { cx: '15', cy: '12', r: '1' }],
        ['circle', { cx: '15', cy: '5', r: '1' }],
        ['circle', { cx: '15', cy: '19', r: '1' }],
    ],
];

const Hammer = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M15 12l-8.5 8.5c-.83.83-2.17.83-3 0 0 0 0 0 0 0a2.12 2.12 0 010-3L12 9',
            },
        ],
        ['path', { d: 'M17.64 15L22 10.64' }],
        [
            'path',
            {
                d: 'M20.91 11.7l-1.25-1.25c-.6-.6-.93-1.4-.93-2.25v-.86L16.01 4.6a5.56 5.56 0 00-3.94-1.64H9l.92.82A6.18 6.18 0 0112 8.4v1.56l2 2h2.47l2.26 1.91',
            },
        ],
    ],
];

const HandMetal = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18 12.5V10a2 2 0 00-2-2v0a2 2 0 00-2 2v1.4' }],
        ['path', { d: 'M14 11V9a2 2 0 10-4 0v2' }],
        ['path', { d: 'M10 10.5V5a2 2 0 10-4 0v9' }],
        [
            'path',
            {
                d: 'M7 15l-1.76-1.76a2 2 0 00-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 008-8V7a2 2 0 10-4 0v5',
            },
        ],
    ],
];

const Hand = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18 11V6a2 2 0 00-2-2v0a2 2 0 00-2 2v0' }],
        ['path', { d: 'M14 10V4a2 2 0 00-2-2v0a2 2 0 00-2 2v2' }],
        ['path', { d: 'M10 10.5V6a2 2 0 00-2-2v0a2 2 0 00-2 2v8' }],
        [
            'path',
            {
                d: 'M18 8a2 2 0 114 0v6a8 8 0 01-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 012.83-2.82L7 15',
            },
        ],
    ],
];

const HardDrive = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '22', y1: '12', x2: '2', y2: '12' }],
        [
            'path',
            {
                d: 'M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z',
            },
        ],
        ['line', { x1: '6', y1: '16', x2: '6.01', y2: '16' }],
        ['line', { x1: '10', y1: '16', x2: '10.01', y2: '16' }],
    ],
];

const HardHat = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M2 18a1 1 0 001 1h18a1 1 0 001-1v-2a1 1 0 00-1-1H3a1 1 0 00-1 1v2z',
            },
        ],
        ['path', { d: 'M10 10V5a1 1 0 011-1h2a1 1 0 011 1v5' }],
        ['path', { d: 'M4 15v-3a6 6 0 016-6h0' }],
        ['path', { d: 'M14 6h0a6 6 0 016 6v3' }],
    ],
];

const Hash = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '4', y1: '9', x2: '20', y2: '9' }],
        ['line', { x1: '4', y1: '15', x2: '20', y2: '15' }],
        ['line', { x1: '10', y1: '3', x2: '8', y2: '21' }],
        ['line', { x1: '16', y1: '3', x2: '14', y2: '21' }],
    ],
];

const Haze = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M5.2 6.2l1.4 1.4' }],
        ['path', { d: 'M2 13h2' }],
        ['path', { d: 'M20 13h2' }],
        ['path', { d: 'M17.4 7.6l1.4-1.4' }],
        ['path', { d: 'M22 17H2' }],
        ['path', { d: 'M22 21H2' }],
        ['path', { d: 'M16 13a4 4 0 00-8 0' }],
        ['path', { d: 'M12 5V2.5' }],
    ],
];

const Headphones = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M3 18v-6a9 9 0 0118 0v6' }],
        [
            'path',
            {
                d: 'M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z',
            },
        ],
    ],
];

const Heart = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M20.42 4.58a5.4 5.4 0 00-7.65 0l-.77.78-.77-.78a5.4 5.4 0 00-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z',
            },
        ],
    ],
];

const HelpCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['path', { d: 'M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3' }],
        ['line', { x1: '12', y1: '17', x2: '12.01', y2: '17' }],
    ],
];

const Hexagon = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z',
            },
        ],
    ],
];

const Highlighter = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M9 11l-6 6v3h9l3-3' }],
        [
            'path',
            { d: 'M22 12l-4.6 4.6a2 2 0 01-2.8 0l-5.2-5.2a2 2 0 010-2.8L14 4' },
        ],
    ],
];

const History = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M3 3v5h5' }],
        ['path', { d: 'M3.05 13A9 9 0 106 5.3L3 8' }],
        ['path', { d: 'M12 7v5l4 2' }],
    ],
];

const Home = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z' }],
        ['polyline', { points: '9 22 9 12 15 12 15 22' }],
    ],
];

const ImageMinus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 11v8a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h8' }],
        ['path', { d: 'M8.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3z' }],
        ['path', { d: 'M21 15l-5-5L5 21' }],
        ['path', { d: 'M22 5h-6' }],
    ],
];

const ImageOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 2l20 20' }],
        [
            'path',
            {
                d: 'M9 3h10a2 2 0 012 2v10M3.59 3.59A2 2 0 003 5v14c0 1.1.9 2 2 2h14a2 2 0 001.41-.59',
            },
        ],
        ['path', { d: 'M9.56 9.56a1.5 1.5 0 01-2.12-2.12' }],
        ['path', { d: 'M21 15l-5-5M5 21l8-8' }],
    ],
];

const ImagePlus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 11v8a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h8' }],
        ['path', { d: 'M8.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3z' }],
        ['path', { d: 'M21 15l-5-5L5 21' }],
        ['path', { d: 'M19 2v6' }],
        ['path', { d: 'M22 5h-6' }],
    ],
];

const Image = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['circle', { cx: '8.5', cy: '8.5', r: '1.5' }],
        ['polyline', { points: '21 15 16 10 5 21' }],
    ],
];

const Import = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 3v12' }],
        ['path', { d: 'M8 11l4 4 4-4' }],
        [
            'path',
            {
                d: 'M8 5H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2h-4',
            },
        ],
    ],
];

const Inbox = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '22 12 16 12 14 15 10 15 8 12 2 12' }],
        [
            'path',
            {
                d: 'M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z',
            },
        ],
    ],
];

const Indent = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '3 8 7 12 3 16' }],
        ['line', { x1: '21', y1: '12', x2: '11', y2: '12' }],
        ['line', { x1: '21', y1: '6', x2: '11', y2: '6' }],
        ['line', { x1: '21', y1: '18', x2: '11', y2: '18' }],
    ],
];

const IndianRupee = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M6 3h12' }],
        ['path', { d: 'M6 8h12' }],
        ['path', { d: 'M6 13l8.5 8' }],
        ['path', { d: 'M6 13h3' }],
        ['path', { d: 'M9 13c6.667 0 6.667-10 0-10' }],
    ],
];

const Infinity = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.739-8-4.585 0-4.585 8 0 8 5.606 0 7.644-8 12.74-8z',
            },
        ],
    ],
];

const Info = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '12', y1: '16', x2: '12', y2: '12' }],
        ['line', { x1: '12', y1: '8', x2: '12.01', y2: '8' }],
    ],
];

const Inspect = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M19 11V4a2 2 0 00-2-2H4a2 2 0 00-2 2v13a2 2 0 002 2h7' }],
        ['path', { d: 'M12 12l4.166 10 1.48-4.355L22 16.166 12 12z' }],
        ['path', { d: 'M18 18l3 3' }],
    ],
];

const Instagram = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '2', width: '20', height: '20', rx: '5', ry: '5' }],
        ['path', { d: 'M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z' }],
        ['line', { x1: '17.5', y1: '6.5', x2: '17.51', y2: '6.5' }],
    ],
];

const Italic = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '19', y1: '4', x2: '10', y2: '4' }],
        ['line', { x1: '14', y1: '20', x2: '5', y2: '20' }],
        ['line', { x1: '15', y1: '4', x2: '9', y2: '20' }],
    ],
];

const JapaneseYen = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 9.5V21m0-11.5L6 3m6 6.5L18 3' }],
        ['path', { d: 'M6 15h12' }],
        ['path', { d: 'M6 11h12' }],
    ],
];

const Key = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4',
            },
        ],
    ],
];

const Landmark = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '3', y1: '22', x2: '21', y2: '22' }],
        ['line', { x1: '6', y1: '18', x2: '6', y2: '11' }],
        ['line', { x1: '10', y1: '18', x2: '10', y2: '11' }],
        ['line', { x1: '14', y1: '18', x2: '14', y2: '11' }],
        ['line', { x1: '18', y1: '18', x2: '18', y2: '11' }],
        ['polygon', { points: '12 2 20 7 4 7' }],
    ],
];

const Languages = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M5 8l6 6' }],
        ['path', { d: 'M4 14l6-6 2-3' }],
        ['path', { d: 'M2 5h12' }],
        ['path', { d: 'M7 2h1' }],
        ['path', { d: 'M22 22l-5-10-5 10' }],
        ['path', { d: 'M14 18h6' }],
    ],
];

const Laptop2 = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '4', width: '18', height: '12', rx: '2', ry: '2' }],
        ['line', { x1: '2', y1: '20', x2: '22', y2: '20' }],
    ],
];

const Laptop = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M20 16V7a2 2 0 00-2-2H6a2 2 0 00-2 2v9m16 0H4m16 0l1.28 2.55a1 1 0 01-.9 1.45H3.62a1 1 0 01-.9-1.45L4 16',
            },
        ],
    ],
];

const LassoSelect = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M7 22a5 5 0 01-2-4' }],
        ['path', { d: 'M7 16.93c.96.43 1.96.74 2.99.91' }],
        [
            'path',
            {
                d: 'M3.34 14A6.8 6.8 0 012 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 01-.33 2',
            },
        ],
        ['path', { d: 'M5 18a2 2 0 100-4 2 2 0 000 4z' }],
        [
            'path',
            {
                d: 'M14.33 22h-.09a.35.35 0 01-.24-.32v-10a.34.34 0 01.33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 01-.21.59h-4.49l-2.57 3.85a.35.35 0 01-.28.14v0z',
            },
        ],
    ],
];

const Lasso = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M7 22a5 5 0 01-2-4' }],
        [
            'path',
            {
                d: 'M3.3 14A6.8 6.8 0 012 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 01-5-1',
            },
        ],
        ['path', { d: 'M5 18a2 2 0 100-4 2 2 0 000 4z' }],
    ],
];

const Layers = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '12 2 2 7 12 12 22 7 12 2' }],
        ['polyline', { points: '2 17 12 22 22 17' }],
        ['polyline', { points: '2 12 12 17 22 12' }],
    ],
];

const LayoutDashboard = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '7', height: '9' }],
        ['rect', { x: '14', y: '3', width: '7', height: '5' }],
        ['rect', { x: '14', y: '12', width: '7', height: '9' }],
        ['rect', { x: '3', y: '16', width: '7', height: '5' }],
    ],
];

const LayoutGrid = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '7', height: '7' }],
        ['rect', { x: '14', y: '3', width: '7', height: '7' }],
        ['rect', { x: '14', y: '14', width: '7', height: '7' }],
        ['rect', { x: '3', y: '14', width: '7', height: '7' }],
    ],
];

const LayoutList = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '14', width: '7', height: '7' }],
        ['rect', { x: '3', y: '3', width: '7', height: '7' }],
        ['line', { x1: '14', y1: '4', x2: '21', y2: '4' }],
        ['line', { x1: '14', y1: '9', x2: '21', y2: '9' }],
        ['line', { x1: '14', y1: '15', x2: '21', y2: '15' }],
        ['line', { x1: '14', y1: '20', x2: '21', y2: '20' }],
    ],
];

const LayoutTemplate = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 3H3v7h18V3z' }],
        ['path', { d: 'M21 14h-5v7h5v-7z' }],
        ['path', { d: 'M12 14H3v7h9v-7z' }],
    ],
];

const Layout = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '3', y1: '9', x2: '21', y2: '9' }],
        ['line', { x1: '9', y1: '21', x2: '9', y2: '9' }],
    ],
];

const Library = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M16 6l4 14' }],
        ['path', { d: 'M12 6v14' }],
        ['path', { d: 'M8 8v12' }],
        ['path', { d: 'M4 4v16' }],
    ],
];

const LifeBuoy = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['circle', { cx: '12', cy: '12', r: '4' }],
        ['line', { x1: '4.93', y1: '4.93', x2: '9.17', y2: '9.17' }],
        ['line', { x1: '14.83', y1: '14.83', x2: '19.07', y2: '19.07' }],
        ['line', { x1: '14.83', y1: '9.17', x2: '19.07', y2: '4.93' }],
        ['line', { x1: '14.83', y1: '9.17', x2: '18.36', y2: '5.64' }],
        ['line', { x1: '4.93', y1: '19.07', x2: '9.17', y2: '14.83' }],
    ],
];

const LightbulbOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M9 18h6' }],
        ['path', { d: 'M10 22h4' }],
        ['path', { d: 'M2 2l20 20' }],
        [
            'path',
            {
                d: 'M8.91 14a4.61 4.61 0 00-1.41-2.5C6.23 10.23 6 9 6 8a6 6 0 01.084-1M9 2.804A6 6 0 0118 8a4.651 4.651 0 01-1.031 3',
            },
        ],
    ],
];

const Lightbulb = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '9', y1: '18', x2: '15', y2: '18' }],
        ['line', { x1: '10', y1: '22', x2: '14', y2: '22' }],
        [
            'path',
            {
                d: 'M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0018 8 6 6 0 006 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 018.91 14',
            },
        ],
    ],
];

const Link2Off = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M15 7h2a5 5 0 014 8M9 17H7A5 5 0 017 7' }],
        ['line', { x1: '8', y1: '12', x2: '12', y2: '12' }],
        ['line', { x1: '2', y1: '2', x2: '22', y2: '22' }],
    ],
];

const Link2 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M15 7h2a5 5 0 010 10h-2m-6 0H7A5 5 0 017 7h2' }],
        ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
    ],
];

const Link = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71' }],
        [
            'path',
            { d: 'M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71' },
        ],
    ],
];

const Linkedin = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z',
            },
        ],
        ['rect', { x: '2', y: '9', width: '4', height: '12' }],
        ['circle', { cx: '4', cy: '4', r: '2' }],
    ],
];

const ListChecks = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '10', y1: '6', x2: '21', y2: '6' }],
        ['line', { x1: '10', y1: '12', x2: '21', y2: '12' }],
        ['line', { x1: '10', y1: '18', x2: '21', y2: '18' }],
        ['polyline', { points: '3 6 4 7 6 5' }],
        ['polyline', { points: '3 12 4 13 6 11' }],
        ['polyline', { points: '3 18 4 19 6 17' }],
    ],
];

const ListMinus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M11 12H3' }],
        ['path', { d: 'M16 6H3' }],
        ['path', { d: 'M16 18H3' }],
        ['path', { d: 'M21 12h-6' }],
    ],
];

const ListOrdered = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '10', y1: '6', x2: '21', y2: '6' }],
        ['line', { x1: '10', y1: '12', x2: '21', y2: '12' }],
        ['line', { x1: '10', y1: '18', x2: '21', y2: '18' }],
        ['path', { d: 'M4 6h1v4' }],
        ['path', { d: 'M4 10h2' }],
        ['path', { d: 'M6 18H4c0-1 2-2 2-3s-1-1.5-2-1' }],
    ],
];

const ListPlus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M11 12H3' }],
        ['path', { d: 'M16 6H3' }],
        ['path', { d: 'M16 18H3' }],
        ['path', { d: 'M18 9v6' }],
        ['path', { d: 'M21 12h-6' }],
    ],
];

const ListX = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M11 12H3' }],
        ['path', { d: 'M16 6H3' }],
        ['path', { d: 'M16 18H3' }],
        ['path', { d: 'M19 10l-4 4' }],
        ['path', { d: 'M15 10l4 4' }],
    ],
];

const List = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '8', y1: '6', x2: '21', y2: '6' }],
        ['line', { x1: '8', y1: '12', x2: '21', y2: '12' }],
        ['line', { x1: '8', y1: '18', x2: '21', y2: '18' }],
        ['line', { x1: '3', y1: '6', x2: '3.01', y2: '6' }],
        ['line', { x1: '3', y1: '12', x2: '3.01', y2: '12' }],
        ['line', { x1: '3', y1: '18', x2: '3.01', y2: '18' }],
    ],
];

const Loader2 = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M21 12a9 9 0 11-6.219-8.56' }]],
];

const Loader = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '12', y1: '2', x2: '12', y2: '6' }],
        ['line', { x1: '12', y1: '18', x2: '12', y2: '22' }],
        ['line', { x1: '4.93', y1: '4.93', x2: '7.76', y2: '7.76' }],
        ['line', { x1: '16.24', y1: '16.24', x2: '19.07', y2: '19.07' }],
        ['line', { x1: '2', y1: '12', x2: '6', y2: '12' }],
        ['line', { x1: '18', y1: '12', x2: '22', y2: '12' }],
        ['line', { x1: '4.93', y1: '19.07', x2: '7.76', y2: '16.24' }],
        ['line', { x1: '16.24', y1: '7.76', x2: '19.07', y2: '4.93' }],
    ],
];

const LocateFixed = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '2', x2: '5', y1: '12', y2: '12' }],
        ['line', { x1: '19', x2: '22', y1: '12', y2: '12' }],
        ['line', { x1: '12', x2: '12', y1: '2', y2: '5' }],
        ['line', { x1: '12', x2: '12', y1: '19', y2: '22' }],
        ['circle', { cx: '12', cy: '12', r: '7' }],
        ['circle', { cx: '12', cy: '12', r: '3' }],
    ],
];

const Locate = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '2', x2: '5', y1: '12', y2: '12' }],
        ['line', { x1: '19', x2: '22', y1: '12', y2: '12' }],
        ['line', { x1: '12', x2: '12', y1: '2', y2: '5' }],
        ['line', { x1: '12', x2: '12', y1: '19', y2: '22' }],
        ['circle', { cx: '12', cy: '12', r: '7' }],
    ],
];

const Lock = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '11', width: '18', height: '11', rx: '2', ry: '2' }],
        ['path', { d: 'M7 11V7a5 5 0 0110 0v4' }],
    ],
];

const LogIn = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4' }],
        ['polyline', { points: '10 17 15 12 10 7' }],
        ['line', { x1: '15', y1: '12', x2: '3', y2: '12' }],
    ],
];

const LogOut = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4' }],
        ['polyline', { points: '16 17 21 12 16 7' }],
        ['line', { x1: '21', y1: '12', x2: '9', y2: '12' }],
    ],
];

const Mail = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z',
            },
        ],
        ['polyline', { points: '22,6 12,13 2,6' }],
    ],
];

const MapPin = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z' }],
        ['circle', { cx: '12', cy: '10', r: '3' }],
    ],
];

const Map = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6' }],
        ['line', { x1: '8', y1: '2', x2: '8', y2: '18' }],
        ['line', { x1: '16', y1: '6', x2: '16', y2: '22' }],
    ],
];

const Maximize2 = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '15 3 21 3 21 9' }],
        ['polyline', { points: '9 21 3 21 3 15' }],
        ['line', { x1: '21', y1: '3', x2: '14', y2: '10' }],
        ['line', { x1: '3', y1: '21', x2: '10', y2: '14' }],
    ],
];

const Maximize = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3',
            },
        ],
    ],
];

const Megaphone = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M3 11l18-5v12L3 14v-3z' }],
        ['path', { d: 'M11.6 16.8a3 3 0 11-5.8-1.6' }],
    ],
];

const Meh = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '8', y1: '15', x2: '16', y2: '15' }],
        ['line', { x1: '9', y1: '9', x2: '9.01', y2: '9' }],
        ['line', { x1: '15', y1: '9', x2: '15.01', y2: '9' }],
    ],
];

const Menu = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '4', y1: '12', x2: '20', y2: '12' }],
        ['line', { x1: '4', y1: '6', x2: '20', y2: '6' }],
        ['line', { x1: '4', y1: '18', x2: '20', y2: '18' }],
    ],
];

const MessageCircle = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z',
            },
        ],
    ],
];

const MessageSquare = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z' }]],
];

const MicOff = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '1', y1: '1', x2: '23', y2: '23' }],
        ['path', { d: 'M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6' }],
        ['path', { d: 'M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23' }],
        ['line', { x1: '12', y1: '19', x2: '12', y2: '23' }],
        ['line', { x1: '8', y1: '23', x2: '16', y2: '23' }],
    ],
];

const Mic = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z' }],
        ['path', { d: 'M19 10v2a7 7 0 01-14 0v-2' }],
        ['line', { x1: '12', y1: '19', x2: '12', y2: '23' }],
        ['line', { x1: '8', y1: '23', x2: '16', y2: '23' }],
    ],
];

const Minimize2 = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '4 14 10 14 10 20' }],
        ['polyline', { points: '20 10 14 10 14 4' }],
        ['line', { x1: '14', y1: '10', x2: '21', y2: '3' }],
        ['line', { x1: '3', y1: '21', x2: '10', y2: '14' }],
    ],
];

const Minimize = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3',
            },
        ],
    ],
];

const MinusCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
    ],
];

const MinusSquare = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
    ],
];

const Minus = [
    'svg',
    defaultAttributes,
    [['line', { x1: '5', y1: '12', x2: '19', y2: '12' }]],
];

const MonitorOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17 17H4a2 2 0 01-2-2V5c0-1.5 1-2 1-2' }],
        ['path', { d: 'M22 15V5a2 2 0 00-2-2H9' }],
        ['path', { d: 'M8 21h8' }],
        ['path', { d: 'M12 17v4' }],
        ['path', { d: 'M2 2l20 20' }],
    ],
];

const MonitorSpeaker = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M5.5 20H8' }],
        ['path', { d: 'M17 9h.01' }],
        ['rect', { x: '12', y: '4', width: '10', height: '16', rx: '2' }],
        ['path', { d: 'M8 6H4a2 2 0 00-2 2v6a2 2 0 002 2h4' }],
        ['circle', { cx: '17', cy: '15', r: '1' }],
    ],
];

const Monitor = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '3', width: '20', height: '14', rx: '2', ry: '2' }],
        ['line', { x1: '8', y1: '21', x2: '16', y2: '21' }],
        ['line', { x1: '12', y1: '17', x2: '12', y2: '21' }],
    ],
];

const Moon = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z' }]],
];

const MoreHorizontal = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '1' }],
        ['circle', { cx: '19', cy: '12', r: '1' }],
        ['circle', { cx: '5', cy: '12', r: '1' }],
    ],
];

const MoreVertical = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '1' }],
        ['circle', { cx: '12', cy: '5', r: '1' }],
        ['circle', { cx: '12', cy: '19', r: '1' }],
    ],
];

const MountainSnow = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M8 3l4 8 5-5 5 15H2L8 3z' }],
        [
            'path',
            { d: 'M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19' },
        ],
    ],
];

const Mountain = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M8 3l4 8 5-5 5 15H2L8 3z' }]],
];

const MousePointer2 = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M4 4l7.07 17 2.51-7.39L21 11.07z' }]],
];

const MousePointerClick = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M9 9l5 12 1.774-5.226L21 14 9 9z' }],
        ['path', { d: 'M16.071 16.071l4.243 4.243' }],
        [
            'path',
            {
                d: 'M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122',
            },
        ],
    ],
];

const MousePointer = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z' }],
        ['path', { d: 'M13 13l6 6' }],
    ],
];

const MoveDiagonal2 = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '5 11 5 5 11 5' }],
        ['polyline', { points: '19 13 19 19 13 19' }],
        ['line', { x1: '5', y1: '5', x2: '19', y2: '19' }],
    ],
];

const MoveDiagonal = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '13 5 19 5 19 11' }],
        ['polyline', { points: '11 19 5 19 5 13' }],
        ['line', { x1: '19', y1: '5', x2: '5', y2: '19' }],
    ],
];

const MoveHorizontal = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '18 8 22 12 18 16' }],
        ['polyline', { points: '6 8 2 12 6 16' }],
        ['line', { x1: '2', y1: '12', x2: '22', y2: '12' }],
    ],
];

const MoveVertical = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '8 18 12 22 16 18' }],
        ['polyline', { points: '8 6 12 2 16 6' }],
        ['line', { x1: '12', y1: '2', x2: '12', y2: '22' }],
    ],
];

const Move = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '5 9 2 12 5 15' }],
        ['polyline', { points: '9 5 12 2 15 5' }],
        ['polyline', { points: '15 19 12 22 9 19' }],
        ['polyline', { points: '19 9 22 12 19 15' }],
        ['line', { x1: '2', y1: '12', x2: '22', y2: '12' }],
        ['line', { x1: '12', y1: '2', x2: '12', y2: '22' }],
    ],
];

const Music = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M9 18V5l12-2v13' }],
        ['circle', { cx: '6', cy: '18', r: '3' }],
        ['circle', { cx: '18', cy: '16', r: '3' }],
    ],
];

const Navigation2 = [
    'svg',
    defaultAttributes,
    [['polygon', { points: '12 2 19 21 12 17 5 21 12 2' }]],
];

const Navigation = [
    'svg',
    defaultAttributes,
    [['polygon', { points: '3 11 22 2 13 21 11 13 3 11' }]],
];

const Network = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '9', y: '2', width: '6', height: '6' }],
        ['rect', { x: '16', y: '16', width: '6', height: '6' }],
        ['rect', { x: '2', y: '16', width: '6', height: '6' }],
        ['path', { d: 'M12 8v4m0 0H5v4m7-4h7v4' }],
    ],
];

const Octagon = [
    'svg',
    defaultAttributes,
    [
        [
            'polygon',
            {
                points: '7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2',
            },
        ],
    ],
];

const Option = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M3 3h6l6 18h6' }], ['path', { d: 'M14 3h7' }]],
];

const Outdent = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '7 8 3 12 7 16' }],
        ['line', { x1: '21', y1: '12', x2: '11', y2: '12' }],
        ['line', { x1: '21', y1: '6', x2: '11', y2: '6' }],
        ['line', { x1: '21', y1: '18', x2: '11', y2: '18' }],
    ],
];

const Package = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '16.5', y1: '9.4', x2: '7.5', y2: '4.21' }],
        [
            'path',
            {
                d: 'M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z',
            },
        ],
        ['polyline', { points: '3.27 6.96 12 12.01 20.73 6.96' }],
        ['line', { x1: '12', y1: '22.08', x2: '12', y2: '12' }],
    ],
];

const Palette = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '13.5', cy: '6.5', r: '.5' }],
        ['circle', { cx: '17.5', cy: '10.5', r: '.5' }],
        ['circle', { cx: '8.5', cy: '7.5', r: '.5' }],
        ['circle', { cx: '6.5', cy: '12.5', r: '.5' }],
        [
            'path',
            {
                d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 011.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z',
            },
        ],
    ],
];

const Paperclip = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48',
            },
        ],
    ],
];

const PauseCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '10', y1: '15', x2: '10', y2: '9' }],
        ['line', { x1: '14', y1: '15', x2: '14', y2: '9' }],
    ],
];

const PauseOctagon = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M10 15V9' }],
        ['path', { d: 'M14 15V9' }],
        [
            'path',
            {
                d: 'M7.714 2h8.572L22 7.714v8.572L16.286 22H7.714L2 16.286V7.714L7.714 2z',
            },
        ],
    ],
];

const Pause = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '6', y: '4', width: '4', height: '16' }],
        ['rect', { x: '14', y: '4', width: '4', height: '16' }],
    ],
];

const PenTool = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 19l7-7 3 3-7 7-3-3z' }],
        ['path', { d: 'M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z' }],
        ['path', { d: 'M2 2l7.586 7.586' }],
        ['circle', { cx: '11', cy: '11', r: '2' }],
    ],
];

const Pencil = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '18', y1: '2', x2: '22', y2: '6' }],
        ['path', { d: 'M7.5 20.5L19 9l-4-4L3.5 16.5 2 22z' }],
    ],
];

const Percent = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '19', y1: '5', x2: '5', y2: '19' }],
        ['circle', { cx: '6.5', cy: '6.5', r: '2.5' }],
        ['circle', { cx: '17.5', cy: '17.5', r: '2.5' }],
    ],
];

const PersonStanding = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '5', r: '1' }],
        ['path', { d: 'M9 20l3-6 3 6' }],
        ['path', { d: 'M6 8l6 2 6-2' }],
        ['path', { d: 'M12 10v4' }],
    ],
];

const PhoneCall = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M14.05 6A5 5 0 0118 10m-3.95-8a9 9 0 018 7.94m0 7v3a2 2 0 01-2 2h-.19a19.79 19.79 0 01-8.63-3.07 19.52 19.52 0 01-6-6 19.82 19.82 0 01-3.11-8.69A2 2 0 013.93 2h3.18a2 2 0 012 1.72 13 13 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 13 13 0 002.81.7A2 2 0 0122 16.92z',
            },
        ],
    ],
];

const PhoneForwarded = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '18 2 22 6 18 10' }],
        ['line', { x1: '14', y1: '6', x2: '22', y2: '6' }],
        [
            'path',
            {
                d: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z',
            },
        ],
    ],
];

const PhoneIncoming = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '16 2 16 8 22 8' }],
        ['line', { x1: '22', y1: '2', x2: '16', y2: '8' }],
        [
            'path',
            {
                d: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z',
            },
        ],
    ],
];

const PhoneMissed = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '22', y1: '2', x2: '16', y2: '8' }],
        ['line', { x1: '16', y1: '2', x2: '22', y2: '8' }],
        [
            'path',
            {
                d: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z',
            },
        ],
    ],
];

const PhoneOff = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7 2 2 0 011.72 2v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.42 19.42 0 01-3.33-2.67m-2.67-3.34a19.79 19.79 0 01-3.07-8.63A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91',
            },
        ],
        ['line', { x1: '22', y1: '2', x2: '2', y2: '22' }],
    ],
];

const PhoneOutgoing = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '22 8 22 2 16 2' }],
        ['line', { x1: '16', y1: '8', x2: '22', y2: '2' }],
        [
            'path',
            {
                d: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z',
            },
        ],
    ],
];

const Phone = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z',
            },
        ],
    ],
];

const PieChart = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21.21 15.89A10 10 0 118 2.83' }],
        ['path', { d: 'M22 12A10 10 0 0012 2v10z' }],
    ],
];

const PiggyBank = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2h0V5z',
            },
        ],
        ['path', { d: 'M2 9v1c0 1.1.9 2 2 2h1' }],
        ['path', { d: 'M16 11h0' }],
    ],
];

const Pin = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 21v-7' }],
        ['path', { d: 'M9 3v5l-2 4v2h10m0 0h-5m5 0v-2l-2-4V3' }],
        ['path', { d: 'M7 3h10' }],
    ],
];

const Pipette = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 22l2-2h3l7-7' }],
        ['path', { d: 'M4 20v-3l7-7' }],
        [
            'path',
            {
                d: 'M14.29 13.3a1 1 0 001.41 0l.8-.8c.27-.27.27-.72 0-1s-.28-.72 0-1l4.08-4.08a2 2 0 000-2.83l-.17-.17a2 2 0 00-2.83 0L13.5 7.51c-.28.27-.73.27-1 0s-.73-.28-1 0l-.8.79a1 1 0 000 1.41l3.59 3.59z',
            },
        ],
    ],
];

const Plane = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z',
            },
        ],
    ],
];

const PlayCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['polygon', { points: '10 8 16 12 10 16 10 8' }],
    ],
];

const Play = [
    'svg',
    defaultAttributes,
    [['polygon', { points: '5 3 19 12 5 21 5 3' }]],
];

const PlugZap = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M13 2l-2 2.5h3L12 7' }],
        ['path', { d: 'M12 22v-3' }],
        ['path', { d: 'M10 13v-2.5' }],
        ['path', { d: 'M10 12.5v-2' }],
        ['path', { d: 'M14 12.5v-2' }],
        [
            'path',
            {
                d: 'M16 15a2 2 0 00-2-2h-4a2 2 0 00-2 2v2a2 2 0 002 2h4a2 2 0 002-2v-2z',
            },
        ],
    ],
];

const PlusCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '12', y1: '8', x2: '12', y2: '16' }],
        ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
    ],
];

const PlusSquare = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '12', y1: '8', x2: '12', y2: '16' }],
        ['line', { x1: '8', y1: '12', x2: '16', y2: '12' }],
    ],
];

const Plus = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '12', y1: '5', x2: '12', y2: '19' }],
        ['line', { x1: '5', y1: '12', x2: '19', y2: '12' }],
    ],
];

const Pocket = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M4 3h16a2 2 0 012 2v6a10 10 0 01-10 10A10 10 0 012 11V5a2 2 0 012-2z',
            },
        ],
        ['polyline', { points: '8 10 12 14 16 10' }],
    ],
];

const Podcast = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '11', r: '1' }],
        ['path', { d: 'M17.03 18.46a9 9 0 10-10.02.03' }],
        ['path', { d: 'M16.06 13.91a5 5 0 10-7.97.2' }],
        [
            'path',
            { d: 'M11.11 17a.9.9 0 111.78 0l-.52 4.67a.37.37 0 01-.74 0l-.52-4.68z' },
        ],
    ],
];

const Pointer = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M22 14a8 8 0 01-8 8' }],
        ['path', { d: 'M18 11v-1a2 2 0 00-2-2v0a2 2 0 00-2 2v0' }],
        ['path', { d: 'M14 10V9a2 2 0 00-2-2v0a2 2 0 00-2 2v1' }],
        ['path', { d: 'M10 9.5V4a2 2 0 00-2-2v0a2 2 0 00-2 2v10' }],
        [
            'path',
            {
                d: 'M18 11a2 2 0 114 0v3a8 8 0 01-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 012.83-2.82L7 15',
            },
        ],
    ],
];

const PoundSterling = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18 7c0-5.333-8-5.333-8 0' }],
        ['path', { d: 'M10 7v14' }],
        ['path', { d: 'M6 21h12' }],
        ['path', { d: 'M6 13h10' }],
    ],
];

const PowerOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18.36 6.64A9 9 0 0120.77 15M5.63 6.64A9 9 0 1018.706 19' }],
        ['path', { d: 'M12 2v4' }],
        ['path', { d: 'M2 2l20 20' }],
    ],
];

const Power = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M18.36 6.64a9 9 0 11-12.73 0' }],
        ['line', { x1: '12', y1: '2', x2: '12', y2: '12' }],
    ],
];

const Printer = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '6 9 6 2 18 2 18 9' }],
        [
            'path',
            {
                d: 'M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2',
            },
        ],
        ['rect', { x: '6', y: '14', width: '12', height: '8' }],
    ],
];

const QrCode = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '2', width: '8', height: '8' }],
        ['path', { d: 'M6 6h.01' }],
        ['rect', { x: '14', y: '2', width: '8', height: '8' }],
        ['path', { d: 'M18 6h.01' }],
        ['rect', { x: '2', y: '14', width: '8', height: '8' }],
        ['path', { d: 'M6 18h.01' }],
        ['path', { d: 'M14 14h.01' }],
        ['path', { d: 'M18 18h.01' }],
        ['path', { d: 'M18 22h4v-4' }],
        ['path', { d: 'M14 18v4' }],
        ['path', { d: 'M22 14h-4' }],
    ],
];

const Quote = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z',
            },
        ],
        [
            'path',
            {
                d: 'M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z',
            },
        ],
    ],
];

const RadioReceiver = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M5 16v2' }],
        ['path', { d: 'M19 16v2' }],
        ['rect', { x: '2', y: '8', width: '20', height: '8', rx: '2' }],
        ['path', { d: 'M18 12h0' }],
    ],
];

const Radio = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '2' }],
        [
            'path',
            {
                d: 'M16.24 7.76a6 6 0 010 8.49m-8.48-.01a6 6 0 010-8.49m11.31-2.82a10 10 0 010 14.14m-14.14 0a10 10 0 010-14.14',
            },
        ],
    ],
];

const Redo = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 7v6h-6' }],
        ['path', { d: 'M3 17a9 9 0 019-9 9 9 0 016 2.3l3 2.7' }],
    ],
];

const RefreshCcw = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M3 2v6h6' }],
        ['path', { d: 'M21 12A9 9 0 006 5.3L3 8' }],
        ['path', { d: 'M21 22v-6h-6' }],
        ['path', { d: 'M3 12a9 9 0 0015 6.7l3-2.7' }],
    ],
];

const RefreshCw = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 2v6h-6' }],
        ['path', { d: 'M3 12a9 9 0 0115-6.7L21 8' }],
        ['path', { d: 'M3 22v-6h6' }],
        ['path', { d: 'M21 12a9 9 0 01-15 6.7L3 16' }],
    ],
];

const Regex = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17 3v10' }],
        ['path', { d: 'M12.67 5.5l8.66 5' }],
        ['path', { d: 'M12.67 10.5l8.66-5' }],
        [
            'path',
            {
                d: 'M9 17a2 2 0 00-2-2H5a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2z',
            },
        ],
    ],
];

const Repeat1 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17 2l4 4-4 4' }],
        ['path', { d: 'M3 11v-1a4 4 0 014-4h14' }],
        ['path', { d: 'M7 22l-4-4 4-4' }],
        ['path', { d: 'M21 13v1a4 4 0 01-4 4H3' }],
        ['path', { d: 'M11 10h1v4' }],
    ],
];

const Repeat = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17 2l4 4-4 4' }],
        ['path', { d: 'M3 11v-1a4 4 0 014-4h14' }],
        ['path', { d: 'M7 22l-4-4 4-4' }],
        ['path', { d: 'M21 13v1a4 4 0 01-4 4H3' }],
    ],
];

const ReplyAll = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '7 17 2 12 7 7' }],
        ['polyline', { points: '12 17 7 12 12 7' }],
        ['path', { d: 'M22 18v-2a4 4 0 00-4-4H7' }],
    ],
];

const Reply = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '9 17 4 12 9 7' }],
        ['path', { d: 'M20 18v-2a4 4 0 00-4-4H4' }],
    ],
];

const Rewind = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '11 19 2 12 11 5 11 19' }],
        ['polygon', { points: '22 19 13 12 22 5 22 19' }],
    ],
];

const RockingChair = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '3.5 2 6.5 12.5 18 12.5' }],
        ['line', { x1: '9.5', y1: '12.5', x2: '5.5', y2: '20' }],
        ['line', { x1: '15', y1: '12.5', x2: '18.5', y2: '20' }],
        ['path', { d: 'M2.75 18a13 13 0 0018.5 0' }],
    ],
];

const RotateCcw = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M3 2v6h6' }], ['path', { d: 'M3 13a9 9 0 103-7.7L3 8' }]],
];

const RotateCw = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 2v6h-6' }],
        ['path', { d: 'M21 13a9 9 0 11-3-7.7L21 8' }],
    ],
];

const Rss = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 11a9 9 0 019 9' }],
        ['path', { d: 'M4 4a16 16 0 0116 16' }],
        ['circle', { cx: '5', cy: '19', r: '1' }],
    ],
];

const Ruler = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M16 2l6 6L8 22l-6-6L16 2' }],
        ['path', { d: 'M7.5 10.5l2 2' }],
        ['path', { d: 'M10.5 7.5l2 2' }],
        ['path', { d: 'M13.5 4.5l2 2' }],
        ['path', { d: 'M4.5 13.5l2 2' }],
    ],
];

const RussianRuble = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M14 11c5.333 0 5.333-8 0-8' }],
        ['path', { d: 'M6 11h8' }],
        ['path', { d: 'M6 15h8' }],
        ['path', { d: 'M9 21V3' }],
        ['path', { d: 'M9 3h5' }],
    ],
];

const Save = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z' },
        ],
        ['polyline', { points: '17 21 17 13 7 13 7 21' }],
        ['polyline', { points: '7 3 7 8 15 8' }],
    ],
];

const Scale = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M16 16l3-8 3.001 8A5.002 5.002 0 0116 16z' }],
        ['path', { d: 'M2 16l3-8 3.001 8A5.002 5.002 0 012 16z' }],
        ['path', { d: 'M7 21h10' }],
        ['path', { d: 'M12 3v18' }],
        ['path', { d: 'M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2' }],
    ],
];

const ScanLine = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M3 7V5a2 2 0 012-2h2' }],
        ['path', { d: 'M17 3h2a2 2 0 012 2v2' }],
        ['path', { d: 'M21 17v2a2 2 0 01-2 2h-2' }],
        ['path', { d: 'M7 21H5a2 2 0 01-2-2v-2' }],
        ['line', { x1: '7', y1: '12', x2: '17', y2: '12' }],
    ],
];

const Scan = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M3 7V5a2 2 0 012-2h2' }],
        ['path', { d: 'M17 3h2a2 2 0 012 2v2' }],
        ['path', { d: 'M21 17v2a2 2 0 01-2 2h-2' }],
        ['path', { d: 'M7 21H5a2 2 0 01-2-2v-2' }],
    ],
];

const Scissors = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '6', cy: '6', r: '3' }],
        ['circle', { cx: '6', cy: '18', r: '3' }],
        ['line', { x1: '20', y1: '4', x2: '8.12', y2: '15.88' }],
        ['line', { x1: '14.47', y1: '14.48', x2: '20', y2: '20' }],
        ['line', { x1: '8.12', y1: '8.12', x2: '12', y2: '12' }],
    ],
];

const ScreenShareOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M13 3H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2v-3' }],
        ['path', { d: 'M8 21h8' }],
        ['path', { d: 'M12 17v4' }],
        ['path', { d: 'M22 3l-5 5' }],
        ['path', { d: 'M17 3l5 5' }],
    ],
];

const ScreenShare = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M13 3H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2v-3' }],
        ['path', { d: 'M8 21h8' }],
        ['path', { d: 'M12 17v4' }],
        ['path', { d: 'M17 8l5-5' }],
        ['path', { d: 'M17 3h5v5' }],
    ],
];

const Search = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '11', cy: '11', r: '8' }],
        ['line', { x1: '21', y1: '21', x2: '16.65', y2: '16.65' }],
    ],
];

const Send = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '22', y1: '2', x2: '11', y2: '13' }],
        ['polygon', { points: '22 2 15 22 11 13 2 9 22 2' }],
    ],
];

const SeparatorHorizontal = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '3', y1: '12', x2: '21', y2: '12' }],
        ['polyline', { points: '8 8 12 4 16 8' }],
        ['polyline', { points: '16 16 12 20 8 16' }],
    ],
];

const SeparatorVertical = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '12', y1: '3', x2: '12', y2: '21' }],
        ['polyline', { points: '8 8 4 12 8 16' }],
        ['polyline', { points: '16 16 20 12 16 8' }],
    ],
];

const ServerCrash = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M6 10H4a2 2 0 01-2-2V4a2 2 0 012-2h16a2 2 0 012 2v4a2 2 0 01-2 2h-2',
            },
        ],
        [
            'path',
            {
                d: 'M6 14H4a2 2 0 00-2 2v4a2 2 0 002 2h16a2 2 0 002-2v-4a2 2 0 00-2-2h-2',
            },
        ],
        ['path', { d: 'M6 6h.01' }],
        ['path', { d: 'M6 18h.01' }],
        ['path', { d: 'M13 6l-4 6h6l-4 6' }],
    ],
];

const ServerOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M7 2h13a2 2 0 012 2v4a2 2 0 01-2 2h-5' }],
        ['path', { d: 'M10 10L2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 002 2h6z' }],
        ['path', { d: 'M22 17v-1a2 2 0 00-2-2h-1' }],
        ['path', { d: 'M4 14a2 2 0 00-2 2v4a2 2 0 002 2h16.5l1-.5.5.5-8-8H4z' }],
        ['path', { d: 'M6 18h.01' }],
        ['path', { d: 'M2 2l20 20' }],
    ],
];

const Server = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '2', width: '20', height: '8', rx: '2', ry: '2' }],
        ['rect', { x: '2', y: '14', width: '20', height: '8', rx: '2', ry: '2' }],
        ['line', { x1: '6', y1: '6', x2: '6.01', y2: '6' }],
        ['line', { x1: '6', y1: '18', x2: '6.01', y2: '18' }],
    ],
];

const Settings2 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 7h-9' }],
        ['path', { d: 'M14 17H5' }],
        ['circle', { cx: '17', cy: '17', r: '3' }],
        ['circle', { cx: '7', cy: '7', r: '3' }],
    ],
];

const Settings = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M12.22 2h-.44a2 2 0 00-2 2v.18a2 2 0 01-1 1.73l-.43.25a2 2 0 01-2 0l-.15-.08a2 2 0 00-2.73.73l-.22.38a2 2 0 00.73 2.73l.15.1a2 2 0 011 1.72v.51a2 2 0 01-1 1.74l-.15.09a2 2 0 00-.73 2.73l.22.38a2 2 0 002.73.73l.15-.08a2 2 0 012 0l.43.25a2 2 0 011 1.73V20a2 2 0 002 2h.44a2 2 0 002-2v-.18a2 2 0 011-1.73l.43-.25a2 2 0 012 0l.15.08a2 2 0 002.73-.73l.22-.39a2 2 0 00-.73-2.73l-.15-.08a2 2 0 01-1-1.74v-.5a2 2 0 011-1.74l.15-.09a2 2 0 00.73-2.73l-.22-.38a2 2 0 00-2.73-.73l-.15.08a2 2 0 01-2 0l-.43-.25a2 2 0 01-1-1.73V4a2 2 0 00-2-2z',
            },
        ],
        ['circle', { cx: '12', cy: '12', r: '3' }],
    ],
];

const Share2 = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '18', cy: '5', r: '3' }],
        ['circle', { cx: '6', cy: '12', r: '3' }],
        ['circle', { cx: '18', cy: '19', r: '3' }],
        ['line', { x1: '8.59', y1: '13.51', x2: '15.42', y2: '17.49' }],
        ['line', { x1: '15.41', y1: '6.51', x2: '8.59', y2: '10.49' }],
    ],
];

const Share = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8' }],
        ['polyline', { points: '16 6 12 2 8 6' }],
        ['line', { x1: '12', y1: '2', x2: '12', y2: '15' }],
    ],
];

const Sheet = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '3', y1: '9', x2: '21', y2: '9' }],
        ['line', { x1: '3', y1: '15', x2: '21', y2: '15' }],
        ['line', { x1: '9', y1: '9', x2: '9', y2: '21' }],
        ['line', { x1: '15', y1: '9', x2: '15', y2: '21' }],
    ],
];

const ShieldAlert = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' }],
        ['path', { d: 'M12 8v4' }],
        ['path', { d: 'M12 16h.01' }],
    ],
];

const ShieldCheck = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' }],
        ['path', { d: 'M9 12l2 2 4-4' }],
    ],
];

const ShieldClose = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' }],
        ['line', { x1: '9.5', y1: '9', x2: '14.5', y2: '14' }],
        ['line', { x1: '14.5', y1: '9', x2: '9.5', y2: '14' }],
    ],
];

const ShieldOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M19.69 14a6.9 6.9 0 00.31-2V5l-8-3-3.16 1.18' }],
        ['path', { d: 'M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 005.62-4.38' }],
        ['line', { x1: '1', y1: '1', x2: '23', y2: '23' }],
    ],
];

const Shield = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' }]],
];

const Shirt = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.47a1 1 0 00.99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.84l.58-3.47a2 2 0 00-1.34-2.23z',
            },
        ],
    ],
];

const ShoppingBag = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z' }],
        ['line', { x1: '3', y1: '6', x2: '21', y2: '6' }],
        ['path', { d: 'M16 10a4 4 0 01-8 0' }],
    ],
];

const ShoppingCart = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '9', cy: '21', r: '1' }],
        ['circle', { cx: '20', cy: '21', r: '1' }],
        [
            'path',
            { d: 'M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6' },
        ],
    ],
];

const Shovel = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 22v-5l5-5 5 5-5 5z' }],
        ['path', { d: 'M9.5 14.5L16 8' }],
        [
            'path',
            { d: 'M17 2l5 5-.5.5a3.53 3.53 0 01-5 0s0 0 0 0a3.53 3.53 0 010-5L17 2' },
        ],
    ],
];

const Shrink = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M15 15l6 6m-6-6v4.8m0-4.8h4.8' }],
        ['path', { d: 'M9 19.8V15m0 0H4.2M9 15l-6 6' }],
        ['path', { d: 'M15 4.2V9m0 0h4.8M15 9l6-6' }],
        ['path', { d: 'M9 4.2V9m0 0H4.2M9 9L3 3' }],
    ],
];

const Shuffle = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '16 3 21 3 21 8' }],
        ['line', { x1: '4', y1: '20', x2: '21', y2: '3' }],
        ['polyline', { points: '21 16 21 21 16 21' }],
        ['line', { x1: '15', y1: '15', x2: '21', y2: '21' }],
        ['line', { x1: '4', y1: '4', x2: '9', y2: '9' }],
    ],
];

const SidebarClose = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '9', y1: '3', x2: '9', y2: '21' }],
        ['path', { d: 'M17 16l-4-4 4-4' }],
    ],
];

const SidebarOpen = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '9', y1: '3', x2: '9', y2: '21' }],
        ['path', { d: 'M13 8l4 4-4 4' }],
    ],
];

const Sidebar = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '9', y1: '3', x2: '9', y2: '21' }],
    ],
];

const Sigma = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M18 7V4H6l6 8-6 8h12v-3' }]],
];

const SignalHigh = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 20h.01' }],
        ['path', { d: 'M7 20v-4' }],
        ['path', { d: 'M12 20v-8' }],
        ['path', { d: 'M17 20V8' }],
    ],
];

const SignalLow = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M2 20h.01' }], ['path', { d: 'M7 20v-4' }]],
];

const SignalMedium = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 20h.01' }],
        ['path', { d: 'M7 20v-4' }],
        ['path', { d: 'M12 20v-8' }],
    ],
];

const SignalZero = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M2 20h.01' }], ['path', { d: 'M7 20v-4' }]],
];

const Signal = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 20h.01' }],
        ['path', { d: 'M7 20v-4' }],
        ['path', { d: 'M12 20v-8' }],
        ['path', { d: 'M17 20V8' }],
        ['path', { d: 'M22 4v16' }],
    ],
];

const SkipBack = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '19 20 9 12 19 4 19 20' }],
        ['line', { x1: '5', y1: '19', x2: '5', y2: '5' }],
    ],
];

const SkipForward = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '5 4 15 12 5 20 5 4' }],
        ['line', { x1: '19', y1: '5', x2: '19', y2: '19' }],
    ],
];

const Skull = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '9', cy: '12', r: '1' }],
        ['circle', { cx: '15', cy: '12', r: '1' }],
        ['path', { d: 'M8 20v2h8v-2' }],
        ['path', { d: 'M12.5 17l-.5-1-.5 1h1z' }],
        ['path', { d: 'M16 20a2 2 0 001.56-3.25 8 8 0 10-11.12 0A2 2 0 008 20' }],
    ],
];

const Slack = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '13', y: '2', width: '3', height: '8', rx: '1.5' }],
        ['path', { d: 'M19 8.5V10h1.5A1.5 1.5 0 1019 8.5' }],
        ['rect', { x: '8', y: '14', width: '3', height: '8', rx: '1.5' }],
        ['path', { d: 'M5 15.5V14H3.5A1.5 1.5 0 105 15.5' }],
        ['rect', { x: '14', y: '13', width: '8', height: '3', rx: '1.5' }],
        ['path', { d: 'M15.5 19H14v1.5a1.5 1.5 0 101.5-1.5' }],
        ['rect', { x: '2', y: '8', width: '8', height: '3', rx: '1.5' }],
        ['path', { d: 'M8.5 5H10V3.5A1.5 1.5 0 108.5 5' }],
    ],
];

const Slash = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '4.93', y1: '4.93', x2: '19.07', y2: '19.07' }],
    ],
];

const Sliders = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '4', y1: '21', x2: '4', y2: '14' }],
        ['line', { x1: '4', y1: '10', x2: '4', y2: '3' }],
        ['line', { x1: '12', y1: '21', x2: '12', y2: '12' }],
        ['line', { x1: '12', y1: '8', x2: '12', y2: '3' }],
        ['line', { x1: '20', y1: '21', x2: '20', y2: '16' }],
        ['line', { x1: '20', y1: '12', x2: '20', y2: '3' }],
        ['line', { x1: '1', y1: '14', x2: '7', y2: '14' }],
        ['line', { x1: '9', y1: '8', x2: '15', y2: '8' }],
        ['line', { x1: '17', y1: '16', x2: '23', y2: '16' }],
    ],
];

const SmartphoneCharging = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '5', y: '2', width: '14', height: '20', rx: '2', ry: '2' }],
        ['path', { d: 'M12.667 8L10 12h4l-2.667 4' }],
    ],
];

const Smartphone = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '5', y: '2', width: '14', height: '20', rx: '2', ry: '2' }],
        ['path', { d: 'M12 18h.01' }],
    ],
];

const Smile = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['path', { d: 'M8 14s1.5 2 4 2 4-2 4-2' }],
        ['line', { x1: '9', y1: '9', x2: '9.01', y2: '9' }],
        ['line', { x1: '15', y1: '9', x2: '15.01', y2: '9' }],
    ],
];

const Snowflake = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '2', y1: '12', x2: '22', y2: '12' }],
        ['line', { x1: '12', y1: '2', x2: '12', y2: '22' }],
        ['path', { d: 'M20 16l-4-4 4-4' }],
        ['path', { d: 'M4 8l4 4-4 4' }],
        ['path', { d: 'M16 4l-4 4-4-4' }],
        ['path', { d: 'M8 20l4-4 4 4' }],
    ],
];

const SortAsc = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M11 5h4' }],
        ['path', { d: 'M11 9h7' }],
        ['path', { d: 'M11 13h10' }],
        ['path', { d: 'M3 17l3 3 3-3' }],
        ['path', { d: 'M6 18V4' }],
    ],
];

const SortDesc = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M11 5h10' }],
        ['path', { d: 'M11 9h7' }],
        ['path', { d: 'M11 13h4' }],
        ['path', { d: 'M3 17l3 3 3-3' }],
        ['path', { d: 'M6 18V4' }],
    ],
];

const Speaker = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '4', y: '2', width: '16', height: '20', rx: '2', ry: '2' }],
        ['circle', { cx: '12', cy: '14', r: '4' }],
        ['line', { x1: '12', y1: '6', x2: '12.01', y2: '6' }],
    ],
];

const Sprout = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M7 20h10' }],
        ['path', { d: 'M10 20c5.5-2.5.8-6.4 3-10' }],
        [
            'path',
            {
                d: 'M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z',
            },
        ],
        [
            'path',
            {
                d: 'M14.1 6a7 7 0 00-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z',
            },
        ],
    ],
];

const Square = [
    'svg',
    defaultAttributes,
    [['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }]],
];

const StarHalf = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M12 17.8L5.8 21 7 14.1 2 9.3l7-1L12 2' }]],
];

const Star = [
    'svg',
    defaultAttributes,
    [
        [
            'polygon',
            {
                points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2',
            },
        ],
    ],
];

const StopCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['rect', { x: '9', y: '9', width: '6', height: '6' }],
    ],
];

const Strikethrough = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M16 4H9a3 3 0 00-2.83 4' }],
        ['path', { d: 'M14 12a4 4 0 010 8H6' }],
        ['line', { x1: '4', y1: '12', x2: '20', y2: '12' }],
    ],
];

const Subscript = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M4 5l8 8' }],
        ['path', { d: 'M12 5l-8 8' }],
        [
            'path',
            {
                d: 'M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 00-2.62-.44c-.42.24-.74.62-.9 1.07',
            },
        ],
    ],
];

const Sun = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '4' }],
        ['path', { d: 'M12 2v2' }],
        ['path', { d: 'M12 20v2' }],
        ['path', { d: 'M5 5l1.5 1.5' }],
        ['path', { d: 'M17.5 17.5L19 19' }],
        ['path', { d: 'M2 12h2' }],
        ['path', { d: 'M20 12h2' }],
        ['path', { d: 'M5 19l1.5-1.5' }],
        ['path', { d: 'M17.5 6.5L19 5' }],
    ],
];

const Sunrise = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 2v8' }],
        ['path', { d: 'M5.2 11.2l1.4 1.4' }],
        ['path', { d: 'M2 18h2' }],
        ['path', { d: 'M20 18h2' }],
        ['path', { d: 'M17.4 12.6l1.4-1.4' }],
        ['path', { d: 'M22 22H2' }],
        ['path', { d: 'M8 6l4-4 4 4' }],
        ['path', { d: 'M16 18a4 4 0 00-8 0' }],
    ],
];

const Sunset = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 10V2' }],
        ['path', { d: 'M5.2 11.2l1.4 1.4' }],
        ['path', { d: 'M2 18h2' }],
        ['path', { d: 'M20 18h2' }],
        ['path', { d: 'M17.4 12.6l1.4-1.4' }],
        ['path', { d: 'M22 22H2' }],
        ['path', { d: 'M16 6l-4 4-4-4' }],
        ['path', { d: 'M16 18a4 4 0 00-8 0' }],
    ],
];

const Superscript = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'm4 19 8-8' }],
        ['path', { d: 'm12 19-8-8' }],
        [
            'path',
            {
                d: 'm20 12h-4c0-1.5 0.4417-2 1.5-2.5s2.5-1.1662 2.5-2.4985c7e-4 -0.47197-0.1706-0.92895-0.4837-1.29-0.313-0.36106-0.7475-0.60291-1.2266-0.6827s-0.9719 0.00763-1.3909 0.24676c-0.4191 0.23914-0.7375 0.61457-0.8988 1.0598',
            },
        ],
    ],
];

const SwissFranc = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M10 21V3h8' }],
        ['path', { d: 'M6 16h9' }],
        ['path', { d: 'M10 9.5h7' }],
    ],
];

const SwitchCamera = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M11 19H4a2 2 0 01-2-2V7a2 2 0 012-2h5' }],
        ['path', { d: 'M13 5h7a2 2 0 012 2v10a2 2 0 01-2 2h-5' }],
        ['circle', { cx: '12', cy: '12', r: '3' }],
        ['path', { d: 'M18 22l-3-3 3-3' }],
        ['path', { d: 'M6 2l3 3-3 3' }],
    ],
];

const Table = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '3', y1: '9', x2: '21', y2: '9' }],
        ['line', { x1: '3', y1: '15', x2: '21', y2: '15' }],
        ['line', { x1: '12', y1: '3', x2: '12', y2: '21' }],
    ],
];

const Tablet = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '4', y: '2', width: '16', height: '20', rx: '2', ry: '2' }],
        ['line', { x1: '12', y1: '18', x2: '12.01', y2: '18' }],
    ],
];

const Tag = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z',
            },
        ],
        ['line', { x1: '7', y1: '7', x2: '7.01', y2: '7' }],
    ],
];

const Target = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['circle', { cx: '12', cy: '12', r: '6' }],
        ['circle', { cx: '12', cy: '12', r: '2' }],
    ],
];

const Tent = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M19 20L10 4' }],
        ['path', { d: 'M5 20l9-16' }],
        ['path', { d: 'M3 20h18' }],
        ['path', { d: 'M12 15l-3 5' }],
        ['path', { d: 'M12 15l3 5' }],
    ],
];

const TerminalSquare = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M7 11l2-2-2-2' }],
        ['path', { d: 'M11 13h4' }],
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
    ],
];

const Terminal = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '4 17 10 11 4 5' }],
        ['line', { x1: '12', y1: '19', x2: '20', y2: '19' }],
    ],
];

const TextCursorInput = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M5.3 4h.9C7.7 4 9 5.3 9 6.7m0 0v10.5c0 1.6-1.1 2.7-2.7 2.7h-1M9 6.7v10.6a2.6 2.6 0 0 0 2.7 2.7h1M9 6.7C9 5.2 10.2 4 11.8 4h.9',
            },
        ],
        [
            'path',
            { d: 'M13.1 7.9h6.8c1.1 0 2.1 1 2.1 2.1v4c0 1.1-.9 2.1-2.1 2.1h-6.8' },
        ],
        [
            'path',
            { d: 'M4.8 16.1h-.7C3 16.1 2 15.1 2 14v-4c0-1.1 1-2.1 2.1-2.1h.7' },
        ],
    ],
];

const TextCursor = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1' }],
        ['path', { d: 'M7 22h1a4 4 0 0 0 4-4v-1' }],
        ['path', { d: 'M7 2h1a4 4 0 0 1 4 4v1' }],
    ],
];

const ThermometerSnowflake = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 12h10' }],
        ['path', { d: 'M9 4v16' }],
        ['path', { d: 'M3 9l3 3-3 3' }],
        ['path', { d: 'M12 6L9 9 6 6' }],
        ['path', { d: 'M6 18l3-3 1.5 1.5' }],
        ['path', { d: 'M18 2a2 2 0 00-2 2v10.5a4 4 0 104 0V4a2 2 0 00-2-2z' }],
    ],
];

const ThermometerSun = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M12 9a4 4 0 00-2 7.5' }],
        ['path', { d: 'M12 3v2' }],
        ['path', { d: 'M6.6 18.4l-1.4 1.4' }],
        ['path', { d: 'M18 2a2 2 0 012 2v10.5a4 4 0 11-4 0V4c0-1.1.9-2 2-2z' }],
        ['path', { d: 'M4 13H2' }],
        ['path', { d: 'M6.6 7.6L5.2 6.2' }],
    ],
];

const Thermometer = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M12 2a2 2 0 00-2 2v10.5a4 4 0 104 0V4a2 2 0 00-2-2z' }]],
];

const ThumbsDown = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M10 15v4a3 3 0 003 3l4-9V2H5.72a2 2 0 00-2 1.7l-1.38 9a2 2 0 002 2.3zm7-13h2.67A2.31 2.31 0 0122 4v7a2.31 2.31 0 01-2.33 2H17',
            },
        ],
    ],
];

const ThumbsUp = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3',
            },
        ],
    ],
];

const Ticket = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M3 9V7a2 2 0 012-2h14a2 2 0 012 2v2M3 15v2a2 2 0 002 2h14a2 2 0 002-2v-2',
            },
        ],
        ['path', { d: 'M21 15a3 3 0 110-6' }],
        ['path', { d: 'M3 15a3 3 0 100-6' }],
        ['path', { d: 'M13 5v2' }],
        ['path', { d: 'M13 17v2' }],
        ['path', { d: 'M13 11v2' }],
    ],
];

const TimerOff = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M10 2h4' }],
        [
            'path',
            { d: 'M7.43 7.433A8 8 0 0118.566 18.57M4.582 11A8 8 0 0015 21.419' },
        ],
        ['path', { d: 'M2 2l20 20' }],
        ['path', { d: 'M12 12v-2' }],
    ],
];

const TimerReset = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M10 2h4' }],
        ['path', { d: 'M12 14v-4' }],
        ['path', { d: 'M4 13a8 8 0 018-7 8 8 0 11-5.3 14L4 17.6' }],
        ['path', { d: 'M9 17H4v5' }],
    ],
];

const Timer = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '10', x2: '14', y1: '2', y2: '2' }],
        ['line', { x1: '12', x2: '15', y1: '14', y2: '11' }],
        ['circle', { cx: '12', cy: '14', r: '8' }],
    ],
];

const ToggleLeft = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '1', y: '5', width: '22', height: '14', rx: '7', ry: '7' }],
        ['circle', { cx: '8', cy: '12', r: '3' }],
    ],
];

const ToggleRight = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '1', y: '5', width: '22', height: '14', rx: '7', ry: '7' }],
        ['circle', { cx: '16', cy: '12', r: '3' }],
    ],
];

const Tornado = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 4H3' }],
        ['path', { d: 'M18 8H6' }],
        ['path', { d: 'M19 12H9' }],
        ['path', { d: 'M16 16h-6' }],
        ['path', { d: 'M11 20H9' }],
    ],
];

const Trash2 = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '3 6 5 6 21 6' }],
        [
            'path',
            {
                d: 'M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2',
            },
        ],
        ['line', { x1: '10', y1: '11', x2: '10', y2: '17' }],
        ['line', { x1: '14', y1: '11', x2: '14', y2: '17' }],
    ],
];

const Trash = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '3 6 5 6 21 6' }],
        [
            'path',
            {
                d: 'M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2',
            },
        ],
    ],
];

const Trello = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['rect', { x: '7', y: '7', width: '3', height: '9' }],
        ['rect', { x: '14', y: '7', width: '3', height: '5' }],
    ],
];

const TrendingDown = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '23 18 13.5 8.5 8.5 13.5 1 6' }],
        ['polyline', { points: '17 18 23 18 23 12' }],
    ],
];

const TrendingUp = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '23 6 13.5 15.5 8.5 10.5 1 18' }],
        ['polyline', { points: '17 6 23 6 23 12' }],
    ],
];

const Triangle = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z',
            },
        ],
    ],
];

const Truck = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M10 17h4V5H2v12h3m15 0h2v-3.34a4 4 0 00-1.17-2.83L19 9h-5v8h1' },
        ],
        ['circle', { cx: '7.5', cy: '17.5', r: '2.5' }],
        ['circle', { cx: '17.5', cy: '17.5', r: '2.5' }],
    ],
];

const Tv2 = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M7 21h10' }],
        ['rect', { x: '2', y: '3', width: '20', height: '14', rx: '2' }],
    ],
];

const Tv = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '2', y: '7', width: '20', height: '15', rx: '2', ry: '2' }],
        ['polyline', { points: '17 2 12 7 7 2' }],
    ],
];

const Twitch = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7' }]],
];

const Twitter = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5 0-.28-.03-.56-.08-.83A7.72 7.72 0 0023 3z',
            },
        ],
    ],
];

const Type = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '4 7 4 4 20 4 20 7' }],
        ['line', { x1: '9', y1: '20', x2: '15', y2: '20' }],
        ['line', { x1: '12', y1: '4', x2: '12', y2: '20' }],
    ],
];

const Umbrella = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M23 12a11.05 11.05 0 00-22 0zm-5 7a3 3 0 01-6 0v-7' }]],
];

const Underline = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M6 4v6a6 6 0 0012 0V4' }],
        ['line', { x1: '4', y1: '20', x2: '20', y2: '20' }],
    ],
];

const Undo = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M3 7v6h6' }],
        ['path', { d: 'M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13' }],
    ],
];

const Unlink2 = [
    'svg',
    defaultAttributes,
    [['path', { d: 'M15 7h2a5 5 0 010 10h-2m-6 0H7A5 5 0 017 7h2' }]],
];

const Unlink = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M18.84 12.25l1.72-1.71h-.02a5.004 5.004 0 00-.12-7.07 5.006 5.006 0 00-6.95 0l-1.72 1.71',
            },
        ],
        [
            'path',
            {
                d: 'M5.17 11.75l-1.71 1.71a5.004 5.004 0 00.12 7.07 5.006 5.006 0 006.95 0l1.71-1.71',
            },
        ],
        ['line', { x1: '8', y1: '2', x2: '8', y2: '5' }],
        ['line', { x1: '2', y1: '8', x2: '5', y2: '8' }],
        ['line', { x1: '16', y1: '19', x2: '16', y2: '22' }],
        ['line', { x1: '19', y1: '16', x2: '22', y2: '16' }],
    ],
];

const Unlock = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '11', width: '18', height: '11', rx: '2', ry: '2' }],
        ['path', { d: 'M7 11V7a5 5 0 019.9-1' }],
    ],
];

const UploadCloud = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 16.2A4.5 4.5 0 0017.5 8h-1.8A7 7 0 104 14.9' }],
        ['path', { d: 'M12 12v9' }],
        ['path', { d: 'M16 16l-4-4-4 4' }],
    ],
];

const Upload = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4' }],
        ['polyline', { points: '17 8 12 3 7 8' }],
        ['line', { x1: '12', y1: '3', x2: '12', y2: '15' }],
    ],
];

const UserCheck = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2' }],
        ['circle', { cx: '8.5', cy: '7', r: '4' }],
        ['polyline', { points: '17 11 19 13 23 9' }],
    ],
];

const UserMinus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2' }],
        ['circle', { cx: '8.5', cy: '7', r: '4' }],
        ['line', { x1: '23', y1: '11', x2: '17', y2: '11' }],
    ],
];

const UserPlus = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2' }],
        ['circle', { cx: '8.5', cy: '7', r: '4' }],
        ['line', { x1: '20', y1: '8', x2: '20', y2: '14' }],
        ['line', { x1: '23', y1: '11', x2: '17', y2: '11' }],
    ],
];

const UserX = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2' }],
        ['circle', { cx: '8.5', cy: '7', r: '4' }],
        ['line', { x1: '18', y1: '8', x2: '23', y2: '13' }],
        ['line', { x1: '23', y1: '8', x2: '18', y2: '13' }],
    ],
];

const User = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2' }],
        ['circle', { cx: '12', cy: '7', r: '4' }],
    ],
];

const Users = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2' }],
        ['circle', { cx: '9', cy: '7', r: '4' }],
        ['path', { d: 'M23 21v-2a4 4 0 00-3-3.87' }],
        ['path', { d: 'M16 3.13a4 4 0 010 7.75' }],
    ],
];

const Verified = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M12 3a3.6 3.6 0 00-3.05 1.68 3.6 3.6 0 00-.9-.1 3.6 3.6 0 00-2.42 1.06 3.6 3.6 0 00-.94 3.32A3.6 3.6 0 003 12a3.6 3.6 0 001.69 3.05 3.6 3.6 0 00.95 3.32 3.6 3.6 0 003.35.96A3.6 3.6 0 0012 21a3.6 3.6 0 003.04-1.67 3.6 3.6 0 004.3-4.3A3.6 3.6 0 0021 12a3.6 3.6 0 00-1.67-3.04v0a3.6 3.6 0 00-4.3-4.3A3.6 3.6 0 0012 3z',
            },
        ],
        ['path', { d: 'M15 10l-4 4' }],
        ['path', { d: 'M9 12l2 2' }],
    ],
];

const Vibrate = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M2 8l2 2-2 2 2 2-2 2' }],
        ['path', { d: 'M22 8l-2 2 2 2-2 2 2 2' }],
        ['rect', { x: '8', y: '5', width: '8', height: '14', rx: '1' }],
    ],
];

const VideoOff = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M16 16v1a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2h2m5.66 0H14a2 2 0 012 2v3.34l1 1L23 7v10',
            },
        ],
        ['line', { x1: '1', y1: '1', x2: '23', y2: '23' }],
    ],
];

const Video = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '23 7 16 12 23 17 23 7' }],
        ['rect', { x: '1', y: '5', width: '15', height: '14', rx: '2', ry: '2' }],
    ],
];

const View = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            { d: 'M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z' },
        ],
        ['path', { d: 'M12 13a1 1 0 100-2 1 1 0 000 2z' }],
        [
            'path',
            {
                d: 'M21 8V5a2 2 0 00-2-2H5a2 2 0 00-2 2v3m18 8v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3',
            },
        ],
    ],
];

const Voicemail = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '5.5', cy: '11.5', r: '4.5' }],
        ['circle', { cx: '18.5', cy: '11.5', r: '4.5' }],
        ['line', { x1: '5.5', y1: '16', x2: '18.5', y2: '16' }],
    ],
];

const Volume1 = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5' }],
        ['path', { d: 'M15.54 8.46a5 5 0 010 7.07' }],
    ],
];

const Volume2 = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5' }],
        ['path', { d: 'M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07' }],
    ],
];

const VolumeX = [
    'svg',
    defaultAttributes,
    [
        ['polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5' }],
        ['line', { x1: '23', y1: '9', x2: '17', y2: '15' }],
        ['line', { x1: '17', y1: '9', x2: '23', y2: '15' }],
    ],
];

const Volume = [
    'svg',
    defaultAttributes,
    [['polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5' }]],
];

const Wallet = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M20 12V8H6a2 2 0 01-2-2c0-1.1.9-2 2-2h12v4' }],
        ['path', { d: 'M4 6v12c0 1.1.9 2 2 2h14v-4' }],
        ['path', { d: 'M18 12a2 2 0 00-2 2c0 1.1.9 2 2 2h4v-4h-4z' }],
    ],
];

const Wand = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M15 4V2' }],
        ['path', { d: 'M15 16v-2' }],
        ['path', { d: 'M8 9h2' }],
        ['path', { d: 'M20 9h2' }],
        ['path', { d: 'M17.8 11.8L19 13' }],
        ['path', { d: 'M15 9h0' }],
        ['path', { d: 'M17.8 6.2L19 5' }],
        ['path', { d: 'M3 21l9-9' }],
        ['path', { d: 'M12.2 6.2L11 5' }],
    ],
];

const Watch = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '7' }],
        ['polyline', { points: '12 9 12 12 13.5 13.5' }],
        [
            'path',
            {
                d: 'M16.51 17.35l-.35 3.83a2 2 0 01-2 1.82H9.83a2 2 0 01-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 019.83 1h4.35a2 2 0 012 1.82l.35 3.83',
            },
        ],
    ],
];

const Webcam = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '10', r: '8' }],
        ['circle', { cx: '12', cy: '10', r: '3' }],
        ['path', { d: 'M12 22v-4m-5 4h5-5zm10 0h-5 5z' }],
    ],
];

const WifiOff = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '2', y1: '2', x2: '22', y2: '22' }],
        ['path', { d: 'M8.5 16.5a5 5 0 017 0' }],
        ['path', { d: 'M2 8.82a15 15 0 014.17-2.65' }],
        ['path', { d: 'M10.66 5c4.01-.36 8.14.9 11.34 3.76' }],
        ['path', { d: 'M16.85 11.25a10 10 0 012.22 1.68' }],
        ['path', { d: 'M5 13a10 10 0 015.24-2.76' }],
        ['line', { x1: '12', y1: '20', x2: '12.01', y2: '20' }],
    ],
];

const Wifi = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M5 13a10 10 0 0114 0' }],
        ['path', { d: 'M8.5 16.5a5 5 0 017 0' }],
        ['path', { d: 'M2 8.82a15 15 0 0120 0' }],
        ['line', { x1: '12', y1: '20', x2: '12.01', y2: '20' }],
    ],
];

const Wind = [
    'svg',
    defaultAttributes,
    [
        ['path', { d: 'M17.7 7.7a2.5 2.5 0 111.8 4.3H2' }],
        ['path', { d: 'M9.6 4.6A2 2 0 1111 8H2' }],
        ['path', { d: 'M12.6 19.4A2 2 0 1014 16H2' }],
    ],
];

const WrapText = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '3', y1: '6', x2: '21', y2: '6' }],
        ['path', { d: 'M3 12h15a3 3 0 110 6h-4' }],
        ['polyline', { points: '16 16 14 18 16 20' }],
        ['line', { x1: '3', y1: '18', x2: '10', y2: '18' }],
    ],
];

const Wrench = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z',
            },
        ],
    ],
];

const XCircle = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '12', cy: '12', r: '10' }],
        ['line', { x1: '15', y1: '9', x2: '9', y2: '15' }],
        ['line', { x1: '9', y1: '9', x2: '15', y2: '15' }],
    ],
];

const XOctagon = [
    'svg',
    defaultAttributes,
    [
        [
            'polygon',
            {
                points: '7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2',
            },
        ],
        ['line', { x1: '15', y1: '9', x2: '9', y2: '15' }],
        ['line', { x1: '9', y1: '9', x2: '15', y2: '15' }],
    ],
];

const XSquare = [
    'svg',
    defaultAttributes,
    [
        ['rect', { x: '3', y: '3', width: '18', height: '18', rx: '2', ry: '2' }],
        ['line', { x1: '9', y1: '9', x2: '15', y2: '15' }],
        ['line', { x1: '15', y1: '9', x2: '9', y2: '15' }],
    ],
];

const X = [
    'svg',
    defaultAttributes,
    [
        ['line', { x1: '18', y1: '6', x2: '6', y2: '18' }],
        ['line', { x1: '6', y1: '6', x2: '18', y2: '18' }],
    ],
];

const Youtube = [
    'svg',
    defaultAttributes,
    [
        [
            'path',
            {
                d: 'M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33A2.78 2.78 0 003.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.25 29 29 0 00-.46-5.33z',
            },
        ],
        ['polygon', { points: '9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02' }],
    ],
];

const ZapOff = [
    'svg',
    defaultAttributes,
    [
        ['polyline', { points: '12.41 6.75 13 2 10.57 4.92' }],
        ['polyline', { points: '18.57 12.91 21 10 15.66 10' }],
        ['polyline', { points: '8 8 3 14 12 14 11 22 16 16' }],
        ['line', { x1: '1', y1: '1', x2: '23', y2: '23' }],
    ],
];

const Zap = [
    'svg',
    defaultAttributes,
    [['polygon', { points: '13 2 3 14 12 14 11 22 21 10 12 10 13 2' }]],
];

const ZoomIn = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '11', cy: '11', r: '8' }],
        ['line', { x1: '21', y1: '21', x2: '16.65', y2: '16.65' }],
        ['line', { x1: '11', y1: '8', x2: '11', y2: '14' }],
        ['line', { x1: '8', y1: '11', x2: '14', y2: '11' }],
    ],
];

const ZoomOut = [
    'svg',
    defaultAttributes,
    [
        ['circle', { cx: '11', cy: '11', r: '8' }],
        ['line', { x1: '21', y1: '21', x2: '16.65', y2: '16.65' }],
        ['line', { x1: '8', y1: '11', x2: '14', y2: '11' }],
    ],
];

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Activity: Activity,
    Airplay: Airplay,
    AlarmCheck: AlarmCheck,
    AlarmClockOff: AlarmClockOff,
    AlarmClock: AlarmClock,
    AlarmMinus: AlarmMinus,
    AlarmPlus: AlarmPlus,
    Album: Album,
    AlertCircle: AlertCircle,
    AlertOctagon: AlertOctagon,
    AlertTriangle: AlertTriangle,
    AlignCenter: AlignCenter,
    AlignJustify: AlignJustify,
    AlignLeft: AlignLeft,
    AlignRight: AlignRight,
    Anchor: Anchor,
    Aperture: Aperture,
    Archive: Archive,
    ArrowBigDown: ArrowBigDown,
    ArrowBigLeft: ArrowBigLeft,
    ArrowBigRight: ArrowBigRight,
    ArrowBigUp: ArrowBigUp,
    ArrowDownCircle: ArrowDownCircle,
    ArrowDownLeft: ArrowDownLeft,
    ArrowDownRight: ArrowDownRight,
    ArrowDown: ArrowDown,
    ArrowLeftCircle: ArrowLeftCircle,
    ArrowLeftRight: ArrowLeftRight,
    ArrowLeft: ArrowLeft,
    ArrowRightCircle: ArrowRightCircle,
    ArrowRight: ArrowRight,
    ArrowUpCircle: ArrowUpCircle,
    ArrowUpLeft: ArrowUpLeft,
    ArrowUpRight: ArrowUpRight,
    ArrowUp: ArrowUp,
    Asterisk: Asterisk,
    AtSign: AtSign,
    Award: Award,
    Axe: Axe,
    Banknote: Banknote,
    BarChart2: BarChart2,
    BarChart: BarChart,
    BatteryCharging: BatteryCharging,
    BatteryFull: BatteryFull,
    BatteryLow: BatteryLow,
    BatteryMedium: BatteryMedium,
    Battery: Battery,
    Beaker: Beaker,
    BellMinus: BellMinus,
    BellOff: BellOff,
    BellPlus: BellPlus,
    BellRing: BellRing,
    Bell: Bell,
    Bike: Bike,
    Binary: Binary,
    Bitcoin: Bitcoin,
    BluetoothConnected: BluetoothConnected,
    BluetoothOff: BluetoothOff,
    BluetoothSearching: BluetoothSearching,
    Bluetooth: Bluetooth,
    Bold: Bold,
    BookOpen: BookOpen,
    Book: Book,
    BookmarkMinus: BookmarkMinus,
    BookmarkPlus: BookmarkPlus,
    Bookmark: Bookmark,
    Bot: Bot,
    BoxSelect: BoxSelect,
    Box: Box,
    Briefcase: Briefcase,
    Brush: Brush,
    Bug: Bug,
    Building: Building,
    Bus: Bus,
    Calculator: Calculator,
    Calendar: Calendar,
    CameraOff: CameraOff,
    Camera: Camera,
    Car: Car,
    Carrot: Carrot,
    Cast: Cast,
    CheckCircle2: CheckCircle2,
    CheckCircle: CheckCircle,
    CheckSquare: CheckSquare,
    Check: Check,
    ChevronDown: ChevronDown,
    ChevronFirst: ChevronFirst,
    ChevronLast: ChevronLast,
    ChevronLeft: ChevronLeft,
    ChevronRight: ChevronRight,
    ChevronUp: ChevronUp,
    ChevronsDownUp: ChevronsDownUp,
    ChevronsDown: ChevronsDown,
    ChevronsLeft: ChevronsLeft,
    ChevronsRight: ChevronsRight,
    ChevronsUpDown: ChevronsUpDown,
    ChevronsUp: ChevronsUp,
    Chrome: Chrome,
    CircleSlashed: CircleSlashed,
    Circle: Circle,
    ClipboardCheck: ClipboardCheck,
    ClipboardCopy: ClipboardCopy,
    ClipboardList: ClipboardList,
    ClipboardX: ClipboardX,
    Clipboard: Clipboard,
    Clock1: Clock1,
    Clock10: Clock10,
    Clock11: Clock11,
    Clock12: Clock12,
    Clock2: Clock2,
    Clock3: Clock3,
    Clock4: Clock4,
    Clock5: Clock5,
    Clock6: Clock6,
    Clock7: Clock7,
    Clock8: Clock8,
    Clock9: Clock9,
    Clock: Clock,
    CloudDrizzle: CloudDrizzle,
    CloudFog: CloudFog,
    CloudHail: CloudHail,
    CloudLightning: CloudLightning,
    CloudMoon: CloudMoon,
    CloudOff: CloudOff,
    CloudRainWind: CloudRainWind,
    CloudRain: CloudRain,
    CloudSnow: CloudSnow,
    CloudSun: CloudSun,
    Cloud: Cloud,
    Cloudy: Cloudy,
    Clover: Clover,
    Code2: Code2,
    Code: Code,
    Codepen: Codepen,
    Codesandbox: Codesandbox,
    Coffee: Coffee,
    Coins: Coins,
    Columns: Columns,
    Command: Command,
    Compass: Compass,
    Contact: Contact,
    Contrast: Contrast,
    Copy: Copy,
    Copyleft: Copyleft,
    Copyright: Copyright,
    CornerDownLeft: CornerDownLeft,
    CornerDownRight: CornerDownRight,
    CornerLeftDown: CornerLeftDown,
    CornerLeftUp: CornerLeftUp,
    CornerRightDown: CornerRightDown,
    CornerRightUp: CornerRightUp,
    CornerUpLeft: CornerUpLeft,
    CornerUpRight: CornerUpRight,
    Cpu: Cpu,
    CreditCard: CreditCard,
    Crop: Crop,
    Cross: Cross,
    Crosshair: Crosshair,
    Crown: Crown,
    Currency: Currency,
    Database: Database,
    Delete: Delete,
    Disc: Disc,
    DivideCircle: DivideCircle,
    DivideSquare: DivideSquare,
    Divide: Divide,
    DollarSign: DollarSign,
    DownloadCloud: DownloadCloud,
    Download: Download,
    Dribbble: Dribbble,
    Droplet: Droplet,
    Droplets: Droplets,
    Drumstick: Drumstick,
    Edit2: Edit2,
    Edit3: Edit3,
    Edit: Edit,
    Egg: Egg,
    EqualNot: EqualNot,
    Equal: Equal,
    Euro: Euro,
    Expand: Expand,
    ExternalLink: ExternalLink,
    EyeOff: EyeOff,
    Eye: Eye,
    Facebook: Facebook,
    FastForward: FastForward,
    Feather: Feather,
    Figma: Figma,
    FileCheck2: FileCheck2,
    FileCheck: FileCheck,
    FileCode: FileCode,
    FileDigit: FileDigit,
    FileInput: FileInput,
    FileMinus2: FileMinus2,
    FileMinus: FileMinus,
    FileOutput: FileOutput,
    FilePlus2: FilePlus2,
    FilePlus: FilePlus,
    FileSearch: FileSearch,
    FileText: FileText,
    FileX2: FileX2,
    FileX: FileX,
    File: File,
    Files: Files,
    Film: Film,
    Filter: Filter,
    FlagTriangleLeft: FlagTriangleLeft,
    FlagTriangleRight: FlagTriangleRight,
    Flag: Flag,
    Flame: Flame,
    FlashlightOff: FlashlightOff,
    Flashlight: Flashlight,
    FlaskConical: FlaskConical,
    FlaskRound: FlaskRound,
    FolderMinus: FolderMinus,
    FolderOpen: FolderOpen,
    FolderPlus: FolderPlus,
    Folder: Folder,
    FormInput: FormInput,
    Forward: Forward,
    Framer: Framer,
    Frown: Frown,
    FunctionSquare: FunctionSquare,
    Gamepad2: Gamepad2,
    Gamepad: Gamepad,
    Gauge: Gauge,
    Gavel: Gavel,
    Gem: Gem,
    Ghost: Ghost,
    Gift: Gift,
    GitBranchPlus: GitBranchPlus,
    GitBranch: GitBranch,
    GitCommit: GitCommit,
    GitMerge: GitMerge,
    GitPullRequest: GitPullRequest,
    Github: Github,
    Gitlab: Gitlab,
    Glasses: Glasses,
    Globe2: Globe2,
    Globe: Globe,
    Grab: Grab,
    GraduationCap: GraduationCap,
    Grid: Grid,
    GripHorizontal: GripHorizontal,
    GripVertical: GripVertical,
    Hammer: Hammer,
    HandMetal: HandMetal,
    Hand: Hand,
    HardDrive: HardDrive,
    HardHat: HardHat,
    Hash: Hash,
    Haze: Haze,
    Headphones: Headphones,
    Heart: Heart,
    HelpCircle: HelpCircle,
    Hexagon: Hexagon,
    Highlighter: Highlighter,
    History: History,
    Home: Home,
    ImageMinus: ImageMinus,
    ImageOff: ImageOff,
    ImagePlus: ImagePlus,
    Image: Image,
    Import: Import,
    Inbox: Inbox,
    Indent: Indent,
    IndianRupee: IndianRupee,
    Infinity: Infinity,
    Info: Info,
    Inspect: Inspect,
    Instagram: Instagram,
    Italic: Italic,
    JapaneseYen: JapaneseYen,
    Key: Key,
    Landmark: Landmark,
    Languages: Languages,
    Laptop2: Laptop2,
    Laptop: Laptop,
    LassoSelect: LassoSelect,
    Lasso: Lasso,
    Layers: Layers,
    LayoutDashboard: LayoutDashboard,
    LayoutGrid: LayoutGrid,
    LayoutList: LayoutList,
    LayoutTemplate: LayoutTemplate,
    Layout: Layout,
    Library: Library,
    LifeBuoy: LifeBuoy,
    LightbulbOff: LightbulbOff,
    Lightbulb: Lightbulb,
    Link2Off: Link2Off,
    Link2: Link2,
    Link: Link,
    Linkedin: Linkedin,
    ListChecks: ListChecks,
    ListMinus: ListMinus,
    ListOrdered: ListOrdered,
    ListPlus: ListPlus,
    ListX: ListX,
    List: List,
    Loader2: Loader2,
    Loader: Loader,
    LocateFixed: LocateFixed,
    Locate: Locate,
    Lock: Lock,
    LogIn: LogIn,
    LogOut: LogOut,
    Mail: Mail,
    MapPin: MapPin,
    Map: Map,
    Maximize2: Maximize2,
    Maximize: Maximize,
    Megaphone: Megaphone,
    Meh: Meh,
    Menu: Menu,
    MessageCircle: MessageCircle,
    MessageSquare: MessageSquare,
    MicOff: MicOff,
    Mic: Mic,
    Minimize2: Minimize2,
    Minimize: Minimize,
    MinusCircle: MinusCircle,
    MinusSquare: MinusSquare,
    Minus: Minus,
    MonitorOff: MonitorOff,
    MonitorSpeaker: MonitorSpeaker,
    Monitor: Monitor,
    Moon: Moon,
    MoreHorizontal: MoreHorizontal,
    MoreVertical: MoreVertical,
    MountainSnow: MountainSnow,
    Mountain: Mountain,
    MousePointer2: MousePointer2,
    MousePointerClick: MousePointerClick,
    MousePointer: MousePointer,
    MoveDiagonal2: MoveDiagonal2,
    MoveDiagonal: MoveDiagonal,
    MoveHorizontal: MoveHorizontal,
    MoveVertical: MoveVertical,
    Move: Move,
    Music: Music,
    Navigation2: Navigation2,
    Navigation: Navigation,
    Network: Network,
    Octagon: Octagon,
    Option: Option,
    Outdent: Outdent,
    Package: Package,
    Palette: Palette,
    Paperclip: Paperclip,
    PauseCircle: PauseCircle,
    PauseOctagon: PauseOctagon,
    Pause: Pause,
    PenTool: PenTool,
    Pencil: Pencil,
    Percent: Percent,
    PersonStanding: PersonStanding,
    PhoneCall: PhoneCall,
    PhoneForwarded: PhoneForwarded,
    PhoneIncoming: PhoneIncoming,
    PhoneMissed: PhoneMissed,
    PhoneOff: PhoneOff,
    PhoneOutgoing: PhoneOutgoing,
    Phone: Phone,
    PieChart: PieChart,
    PiggyBank: PiggyBank,
    Pin: Pin,
    Pipette: Pipette,
    Plane: Plane,
    PlayCircle: PlayCircle,
    Play: Play,
    PlugZap: PlugZap,
    PlusCircle: PlusCircle,
    PlusSquare: PlusSquare,
    Plus: Plus,
    Pocket: Pocket,
    Podcast: Podcast,
    Pointer: Pointer,
    PoundSterling: PoundSterling,
    PowerOff: PowerOff,
    Power: Power,
    Printer: Printer,
    QrCode: QrCode,
    Quote: Quote,
    RadioReceiver: RadioReceiver,
    Radio: Radio,
    Redo: Redo,
    RefreshCcw: RefreshCcw,
    RefreshCw: RefreshCw,
    Regex: Regex,
    Repeat1: Repeat1,
    Repeat: Repeat,
    ReplyAll: ReplyAll,
    Reply: Reply,
    Rewind: Rewind,
    RockingChair: RockingChair,
    RotateCcw: RotateCcw,
    RotateCw: RotateCw,
    Rss: Rss,
    Ruler: Ruler,
    RussianRuble: RussianRuble,
    Save: Save,
    Scale: Scale,
    ScanLine: ScanLine,
    Scan: Scan,
    Scissors: Scissors,
    ScreenShareOff: ScreenShareOff,
    ScreenShare: ScreenShare,
    Search: Search,
    Send: Send,
    SeparatorHorizontal: SeparatorHorizontal,
    SeparatorVertical: SeparatorVertical,
    ServerCrash: ServerCrash,
    ServerOff: ServerOff,
    Server: Server,
    Settings2: Settings2,
    Settings: Settings,
    Share2: Share2,
    Share: Share,
    Sheet: Sheet,
    ShieldAlert: ShieldAlert,
    ShieldCheck: ShieldCheck,
    ShieldClose: ShieldClose,
    ShieldOff: ShieldOff,
    Shield: Shield,
    Shirt: Shirt,
    ShoppingBag: ShoppingBag,
    ShoppingCart: ShoppingCart,
    Shovel: Shovel,
    Shrink: Shrink,
    Shuffle: Shuffle,
    SidebarClose: SidebarClose,
    SidebarOpen: SidebarOpen,
    Sidebar: Sidebar,
    Sigma: Sigma,
    SignalHigh: SignalHigh,
    SignalLow: SignalLow,
    SignalMedium: SignalMedium,
    SignalZero: SignalZero,
    Signal: Signal,
    SkipBack: SkipBack,
    SkipForward: SkipForward,
    Skull: Skull,
    Slack: Slack,
    Slash: Slash,
    Sliders: Sliders,
    SmartphoneCharging: SmartphoneCharging,
    Smartphone: Smartphone,
    Smile: Smile,
    Snowflake: Snowflake,
    SortAsc: SortAsc,
    SortDesc: SortDesc,
    Speaker: Speaker,
    Sprout: Sprout,
    Square: Square,
    StarHalf: StarHalf,
    Star: Star,
    StopCircle: StopCircle,
    Strikethrough: Strikethrough,
    Subscript: Subscript,
    Sun: Sun,
    Sunrise: Sunrise,
    Sunset: Sunset,
    Superscript: Superscript,
    SwissFranc: SwissFranc,
    SwitchCamera: SwitchCamera,
    Table: Table,
    Tablet: Tablet,
    Tag: Tag,
    Target: Target,
    Tent: Tent,
    TerminalSquare: TerminalSquare,
    Terminal: Terminal,
    TextCursorInput: TextCursorInput,
    TextCursor: TextCursor,
    ThermometerSnowflake: ThermometerSnowflake,
    ThermometerSun: ThermometerSun,
    Thermometer: Thermometer,
    ThumbsDown: ThumbsDown,
    ThumbsUp: ThumbsUp,
    Ticket: Ticket,
    TimerOff: TimerOff,
    TimerReset: TimerReset,
    Timer: Timer,
    ToggleLeft: ToggleLeft,
    ToggleRight: ToggleRight,
    Tornado: Tornado,
    Trash2: Trash2,
    Trash: Trash,
    Trello: Trello,
    TrendingDown: TrendingDown,
    TrendingUp: TrendingUp,
    Triangle: Triangle,
    Truck: Truck,
    Tv2: Tv2,
    Tv: Tv,
    Twitch: Twitch,
    Twitter: Twitter,
    Type: Type,
    Umbrella: Umbrella,
    Underline: Underline,
    Undo: Undo,
    Unlink2: Unlink2,
    Unlink: Unlink,
    Unlock: Unlock,
    UploadCloud: UploadCloud,
    Upload: Upload,
    UserCheck: UserCheck,
    UserMinus: UserMinus,
    UserPlus: UserPlus,
    UserX: UserX,
    User: User,
    Users: Users,
    Verified: Verified,
    Vibrate: Vibrate,
    VideoOff: VideoOff,
    Video: Video,
    View: View,
    Voicemail: Voicemail,
    Volume1: Volume1,
    Volume2: Volume2,
    VolumeX: VolumeX,
    Volume: Volume,
    Wallet: Wallet,
    Wand: Wand,
    Watch: Watch,
    Webcam: Webcam,
    WifiOff: WifiOff,
    Wifi: Wifi,
    Wind: Wind,
    WrapText: WrapText,
    Wrench: Wrench,
    XCircle: XCircle,
    XOctagon: XOctagon,
    XSquare: XSquare,
    X: X,
    Youtube: Youtube,
    ZapOff: ZapOff,
    Zap: Zap,
    ZoomIn: ZoomIn,
    ZoomOut: ZoomOut
});

class Icons {
    constructor(icons) {
        this.icons = icons;
    }
}

/**
 * Creates a new SVGElement from icon node
 * @param {string} tag
 * @param {object} attrs
 * @param {array} children
 * @returns {SVGElement}
 */
const createElement = ([tag, attrs, children = []]) => {
    const element = document.createElementNS('http://www.w3.org/2000/svg', tag);
    Object.keys(attrs).forEach(name => {
        element.setAttribute(name, attrs[name]);
    });
    if (children.length) {
        children.forEach((child) => {
            const childElement = createElement(child);
            element.appendChild(childElement);
        });
    }
    return element;
};

class LucideAngularComponent {
    constructor(elem, changeDetector, icons) {
        this.elem = elem;
        this.changeDetector = changeDetector;
        this.icons = icons;
    }
    ngOnChanges(changes) {
        if (changes.name) {
            // icons are provided as an array of objects because of "multi: true"
            const icons = Object.assign({}, ...this.icons);
            const icoOfName = icons[this.toPascalCase(changes.name.currentValue)] || '';
            if (!icoOfName) {
                console.warn(`Icon not found: ${changes.name.currentValue}\n` +
                    `Please check icon name or \'lucide icon list\'`);
            }
            else {
                const icoElement = createElement(icoOfName);
                icoElement.setAttribute('stroke-width', 'inherit');
                icoElement.setAttribute('fill', 'inherit');
                icoElement.removeAttribute('width');
                icoElement.removeAttribute('height');
                this.elem.nativeElement.innerHTML = '';
                this.elem.nativeElement.append(icoElement);
            }
        }
        else if (changes.img) {
            const icoElement = createElement(changes.img.currentValue);
            icoElement.setAttribute('stroke-width', 'inherit');
            icoElement.setAttribute('fill', 'inherit');
            icoElement.removeAttribute('width');
            icoElement.removeAttribute('height');
            this.elem.nativeElement.innerHTML = '';
            this.elem.nativeElement.append(icoElement);
        }
        this.changeDetector.markForCheck();
    }
    toPascalCase(str) {
        return str.replace(/(\w)([a-z0-9]*)(_|-|\s*)/g, (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase());
    }
}
LucideAngularComponent.ɵfac = function LucideAngularComponent_Factory(t) { return new (t || LucideAngularComponent)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(Icons)); };
LucideAngularComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LucideAngularComponent, selectors: [["lucide-angular"], ["lucide-icon"], ["i-lucide"], ["span-lucide"]], inputs: { name: "name", img: "img" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0, decls: 1, vars: 0, template: function LucideAngularComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%] {\n      display: inline-block;\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 2;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      width: 24px;\n      height: 24px;\n    }"] });
LucideAngularComponent.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: Icons, decorators: [{ type: Inject, args: [Icons,] }] }
];
LucideAngularComponent.propDecorators = {
    name: [{ type: Input }],
    img: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LucideAngularComponent, [{
        type: Component,
        args: [{
                selector: 'lucide-angular, lucide-icon, i-lucide, span-lucide',
                template: `<ng-content></ng-content>`,
                styles: [`
    :host {
      display: inline-block;
      fill: none;
      stroke: currentColor;
      stroke-width: 2;
      stroke-linecap: round;
      stroke-linejoin: round;
      width: 24px;
      height: 24px;
    }
  `]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: Icons, decorators: [{
                type: Inject,
                args: [Icons]
            }] }]; }, { name: [{
            type: Input
        }], img: [{
            type: Input
        }] }); })();

class LucideAngularModule {
    constructor(icons) {
        this.icons = icons;
        if (!this.icons) {
            throw new Error(`No icon provided. Make sure to use 'LucideAngularModule.pick({ ... })' when importing the module\n`);
        }
    }
    static pick(icons) {
        return {
            ngModule: LucideAngularModule,
            providers: [
                { provide: Icons, multi: true, useValue: icons }
            ]
        };
    }
}
LucideAngularModule.ɵfac = function LucideAngularModule_Factory(t) { return new (t || LucideAngularModule)(ɵngcc0.ɵɵinject(Icons, 8)); };
LucideAngularModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LucideAngularModule });
LucideAngularModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
LucideAngularModule.ctorParameters = () => [
    { type: Icons, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LucideAngularModule, [{
        type: NgModule,
        args: [{
                declarations: [LucideAngularComponent],
                imports: [],
                exports: [LucideAngularComponent]
            }]
    }], function () { return [{ type: Icons, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LucideAngularModule, { declarations: [LucideAngularComponent], exports: [LucideAngularComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { Activity, Airplay, AlarmCheck, AlarmClock, AlarmClockOff, AlarmMinus, AlarmPlus, Album, AlertCircle, AlertOctagon, AlertTriangle, AlignCenter, AlignJustify, AlignLeft, AlignRight, Anchor, Aperture, Archive, ArrowBigDown, ArrowBigLeft, ArrowBigRight, ArrowBigUp, ArrowDown, ArrowDownCircle, ArrowDownLeft, ArrowDownRight, ArrowLeft, ArrowLeftCircle, ArrowLeftRight, ArrowRight, ArrowRightCircle, ArrowUp, ArrowUpCircle, ArrowUpLeft, ArrowUpRight, Asterisk, AtSign, Award, Axe, Banknote, BarChart, BarChart2, Battery, BatteryCharging, BatteryFull, BatteryLow, BatteryMedium, Beaker, Bell, BellMinus, BellOff, BellPlus, BellRing, Bike, Binary, Bitcoin, Bluetooth, BluetoothConnected, BluetoothOff, BluetoothSearching, Bold, Book, BookOpen, Bookmark, BookmarkMinus, BookmarkPlus, Bot, Box, BoxSelect, Briefcase, Brush, Bug, Building, Bus, Calculator, Calendar, Camera, CameraOff, Car, Carrot, Cast, Check, CheckCircle, CheckCircle2, CheckSquare, ChevronDown, ChevronFirst, ChevronLast, ChevronLeft, ChevronRight, ChevronUp, ChevronsDown, ChevronsDownUp, ChevronsLeft, ChevronsRight, ChevronsUp, ChevronsUpDown, Chrome, Circle, CircleSlashed, Clipboard, ClipboardCheck, ClipboardCopy, ClipboardList, ClipboardX, Clock, Clock1, Clock10, Clock11, Clock12, Clock2, Clock3, Clock4, Clock5, Clock6, Clock7, Clock8, Clock9, Cloud, CloudDrizzle, CloudFog, CloudHail, CloudLightning, CloudMoon, CloudOff, CloudRain, CloudRainWind, CloudSnow, CloudSun, Cloudy, Clover, Code, Code2, Codepen, Codesandbox, Coffee, Coins, Columns, Command, Compass, Contact, Contrast, Copy, Copyleft, Copyright, CornerDownLeft, CornerDownRight, CornerLeftDown, CornerLeftUp, CornerRightDown, CornerRightUp, CornerUpLeft, CornerUpRight, Cpu, CreditCard, Crop, Cross, Crosshair, Crown, Currency, Database, Delete, Disc, Divide, DivideCircle, DivideSquare, DollarSign, Download, DownloadCloud, Dribbble, Droplet, Droplets, Drumstick, Edit, Edit2, Edit3, Egg, Equal, EqualNot, Euro, Expand, ExternalLink, Eye, EyeOff, Facebook, FastForward, Feather, Figma, File, FileCheck, FileCheck2, FileCode, FileDigit, FileInput, FileMinus, FileMinus2, FileOutput, FilePlus, FilePlus2, FileSearch, FileText, FileX, FileX2, Files, Film, Filter, Flag, FlagTriangleLeft, FlagTriangleRight, Flame, Flashlight, FlashlightOff, FlaskConical, FlaskRound, Folder, FolderMinus, FolderOpen, FolderPlus, FormInput, Forward, Framer, Frown, FunctionSquare, Gamepad, Gamepad2, Gauge, Gavel, Gem, Ghost, Gift, GitBranch, GitBranchPlus, GitCommit, GitMerge, GitPullRequest, Github, Gitlab, Glasses, Globe, Globe2, Grab, GraduationCap, Grid, GripHorizontal, GripVertical, Hammer, Hand, HandMetal, HardDrive, HardHat, Hash, Haze, Headphones, Heart, HelpCircle, Hexagon, Highlighter, History, Home, Image, ImageMinus, ImageOff, ImagePlus, Import, Inbox, Indent, IndianRupee, Infinity, Info, Inspect, Instagram, Italic, JapaneseYen, Key, Landmark, Languages, Laptop, Laptop2, Lasso, LassoSelect, Layers, Layout, LayoutDashboard, LayoutGrid, LayoutList, LayoutTemplate, Library, LifeBuoy, Lightbulb, LightbulbOff, Link, Link2, Link2Off, Linkedin, List, ListChecks, ListMinus, ListOrdered, ListPlus, ListX, Loader, Loader2, Locate, LocateFixed, Lock, LogIn, LogOut, LucideAngularComponent, LucideAngularModule, Mail, Map, MapPin, Maximize, Maximize2, Megaphone, Meh, Menu, MessageCircle, MessageSquare, Mic, MicOff, Minimize, Minimize2, Minus, MinusCircle, MinusSquare, Monitor, MonitorOff, MonitorSpeaker, Moon, MoreHorizontal, MoreVertical, Mountain, MountainSnow, MousePointer, MousePointer2, MousePointerClick, Move, MoveDiagonal, MoveDiagonal2, MoveHorizontal, MoveVertical, Music, Navigation, Navigation2, Network, Octagon, Option, Outdent, Package, Palette, Paperclip, Pause, PauseCircle, PauseOctagon, PenTool, Pencil, Percent, PersonStanding, Phone, PhoneCall, PhoneForwarded, PhoneIncoming, PhoneMissed, PhoneOff, PhoneOutgoing, PieChart, PiggyBank, Pin, Pipette, Plane, Play, PlayCircle, PlugZap, Plus, PlusCircle, PlusSquare, Pocket, Podcast, Pointer, PoundSterling, Power, PowerOff, Printer, QrCode, Quote, Radio, RadioReceiver, Redo, RefreshCcw, RefreshCw, Regex, Repeat, Repeat1, Reply, ReplyAll, Rewind, RockingChair, RotateCcw, RotateCw, Rss, Ruler, RussianRuble, Save, Scale, Scan, ScanLine, Scissors, ScreenShare, ScreenShareOff, Search, Send, SeparatorHorizontal, SeparatorVertical, Server, ServerCrash, ServerOff, Settings, Settings2, Share, Share2, Sheet, Shield, ShieldAlert, ShieldCheck, ShieldClose, ShieldOff, Shirt, ShoppingBag, ShoppingCart, Shovel, Shrink, Shuffle, Sidebar, SidebarClose, SidebarOpen, Sigma, Signal, SignalHigh, SignalLow, SignalMedium, SignalZero, SkipBack, SkipForward, Skull, Slack, Slash, Sliders, Smartphone, SmartphoneCharging, Smile, Snowflake, SortAsc, SortDesc, Speaker, Sprout, Square, Star, StarHalf, StopCircle, Strikethrough, Subscript, Sun, Sunrise, Sunset, Superscript, SwissFranc, SwitchCamera, Table, Tablet, Tag, Target, Tent, Terminal, TerminalSquare, TextCursor, TextCursorInput, Thermometer, ThermometerSnowflake, ThermometerSun, ThumbsDown, ThumbsUp, Ticket, Timer, TimerOff, TimerReset, ToggleLeft, ToggleRight, Tornado, Trash, Trash2, Trello, TrendingDown, TrendingUp, Triangle, Truck, Tv, Tv2, Twitch, Twitter, Type, Umbrella, Underline, Undo, Unlink, Unlink2, Unlock, Upload, UploadCloud, User, UserCheck, UserMinus, UserPlus, UserX, Users, Verified, Vibrate, Video, VideoOff, View, Voicemail, Volume, Volume1, Volume2, VolumeX, Wallet, Wand, Watch, Webcam, Wifi, WifiOff, Wind, WrapText, Wrench, X, XCircle, XOctagon, XSquare, Youtube, Zap, ZapOff, ZoomIn, ZoomOut, createElement, index as icons, Icons as ɵa };

